// src/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// --- English Imports ---
import enHeader from './i18n/en/Header.json';
import enShell from './i18n/en/ReactAppShell.json';
import enDashboard from './i18n/en/DashboardPage.json';
import enSearchPage from './i18n/en/SearchPage.json';
import enCaseView from './i18n/en/CaseView.json';
import enMessage from './i18n/en/Message.json';
import enSchedulePage from './i18n/en/SchedulePage.json';
import enAppointmentPage from './i18n/en/AppointmentPage.json';
import enDiseaseProgram from './i18n/en/DiseaseProgramsDashboardPage.json';
import enQuestionnairesPage from './i18n/en/QuestionnairesPage.json';
import enMediaPage from './i18n/en/Media.json';
import enDocumentDashboard from './i18n/en/DocumentDashboard.json';
import enMealPlanner from './i18n/en/MealPlanner.json';
import enOrganization from './i18n/en/OrganizationPage.json';
import enNews from './i18n/en/NewsDashboard.json';
import enPermission from './i18n/en/PermissionSettings.json';
import enPractitioner from './i18n/en/PractitionersPage.json';
import enOrganizational from './i18n/en/OrganizationalSchedules.json';
import enFormPanel from './i18n/en/FormPanel.json';
import enExerciseDashboardPage from './i18n/en/ExerciseDashboardPage.json';
import enClinicalSettingsPage from './i18n/en/ClinicalSettingsPage.json';
import enAdministrativeSettingsPage from './i18n/en/AdministrativeSettingsPage.json';
import enBillingSettingsPage from './i18n/en/BillingSettingsPage.json';
import enStep0Organization from './i18n/en/Step0Org.json';
import enStep1Categories from './i18n/en/Step1Categories.json';
import enChatWindow from './i18n/en/ChatWindow.json';
import enExternalSystemsSettings from './i18n/en/ExternalSystemsSettings.json';
import enOrganizationalSchedules from './i18n/en/OrganizationalSchedules.json';
import enCreateDiseaseProgramPage from './i18n/en/CreateDiseaseProgramPage.json';
import enAppointmentDetailPage from './i18n/en/AppointmentDetailPage.json';
import enAppointmentTasksPanel from './i18n/en/AppointmentTasksPanel.json';
import enOrdersSearchPage from './i18n/en/OrdersSearchPage.json';
import enOrderSearch from './i18n/en/OrderSearch.json';
import enAdminSettingsSections from './i18n/en/AdminSettingsSections.json';
import engenericSection from './i18n/en/genericSection.json';
import enExternalConfigurations from './i18n/en/ExternalConfigurations.json';
import enOrdersPage from './i18n/en/OrdersPage.json';
import enMedicationTab from './i18n/en/MedicationTab.json';
import enNotesVitalsTab from './i18n/en/NotesVitalsTab.json';
import enOrderComposer from './i18n/en/OrderComposer.json';
import enStepOrderSelector from './i18n/en/StepOrderSelector.json';
import enStepCaseAndDetails from './i18n/en/StepCaseAndDetails.json';
import enClinicalSettings from './i18n/en/ClinicalSettings.json';
import enCreateAppointmentPage from './i18n/en/CreateAppointmentPage.json';
import enStepTasks from './i18n/en/StepTasks.json';
import enPrevisitTasks from './i18n/en/PrevisitTasks.json';
import enNewPatientPage from './i18n/en/NewPatientPage.json';
import enAllergiesAndCases from './i18n/en/AllergiesAndCases.json';
import enBillingDashboardPage from './i18n/en/BillingDashboardPage.json';
import enBillingShell from './i18n/en/BillingShell.json';
import enEditPatientPage from './i18n/en/EditPatientPage.json';
import enImmunizationsSection from './i18n/en/ImmunizationsSection.json';
import enIdentitySection from './i18n/en/IdentitySection.json';
import enContactAddressSection from './i18n/en/ContactAddressSection.json';
import enPatientBasicsSection from './i18n/en/PatientBasicsSection.json';
import enCaseEdit from './i18n/en/CaseEdit.json';
import enCaseCaseSections from './i18n/en/CaseCaseSections.json';
import enImmunizationSection from './i18n/en/ImmunizationSection.json';
import enAllergySection from './i18n/en/AllergySection.json';
import enStepGeneralConfig from './i18n/en/StepGeneralConfig.json';
import enPreVisitTasks from './i18n/en/PrevisitTasks.json';
import enPatientSummaryPage from './i18n/en/PatientSummaryPage.json';
import enOverviewPanel from './i18n/en/OverviewPanel.json';
import enAllergiesPanel from './i18n/en/AllergiesPanel.json';
import enPatientHeader from './i18n/en/PatientHeader.json';
import enBedPlannerDashboard from './i18n/en/BedPlannerDashboard.json';
import enCreateDocumentModal from './i18n/en/CreateDocumentModal.json';
import enVideoForm from './i18n/en/VideoForm.json';
import enOrganizationSettings from './i18n/en/OrganizationSettings.json';
import enWorkflowDashboard from './i18n/en/WorkflowDashboard.json';
import enWorkflowCreate from './i18n/en/WorkflowCreate.json';
import enWorkflowTimeSavedSummary from './i18n/en/WorkflowTimeSavedSummary.json';
import enworkflowUtils from './i18n/en/workflowUtils.json';
import enTemplates from './i18n/en/Templates.json';
import enTemplateCreator from './i18n/en/TemplateCreator.json';
import enSharedPatientPage from './i18n/en/SharedPatientPage.json';
import enPdfViewer from './i18n/en/PdfViewer.json';
import enChargesListPage from './i18n/en/ChargesListPage.json';
import enAppointmentOverviewSplitSection from './i18n/en/AppointmentOverviewSplitSection.json';
import enLegalDocumentsPanel from './i18n/en/LegalDocumentsPanel.json';
import enPatientQuestionnairesPanel from './i18n/en/PatientQuestionnairesPanel.json';
import enAssignPatientQuestionnaire from './i18n/en/AssignPatientQuestionnaire.json';
import enCasesImmunizationsPanel from './i18n/en/CasesImmunizationsPanel.json';
import enStepDocuments from './i18n/en/StepDocuments.json';
import enStepReview from './i18n/en/StepReview.json';
import enAppointmentDetailMainSections from './i18n/en/AppointmentDetailMainSections.json';
import enAISummarySection from './i18n/en/AISummarySection.json';
import enClaimsListPage from './i18n/en/ClaimsListPage.json';
import enClaimEditorPage from './i18n/en/ClaimEditorPage.json';
import enReportsLightPage from './i18n/en/ReportsLightPage.json';
import enDenialsAppealsPage from './i18n/en/DenialsAppealsPage.json';
import enARWorklistsPage from './i18n/en/ARWorklistsPage.json';
import enEstimatesPage from './i18n/en/EstimatesPage.json';
import enStatementListPage from './i18n/en/StatementListPage.json';
import enPaymentsPage from './i18n/en/PaymentsPage.json';
import enChargeEditorPage from './i18n/en/ChargeEditorPage.json';
import enImpressum from './i18n/en/Impressum.json';
import enSignInPage from './i18n/en/SignInPage.json';
import enAppointmentsPanel from './i18n/en/AppointmentsPanel.json';
import enAppointmentNotesAndSummariesTab from './i18n/en/AppointmentNotesAndSummariesTab.json';
import enPatientInviteAction from './i18n/en/PatientInviteAction.json';
import enAssignProgramPage from './i18n/en/AssignProgramPage.json';
import enMealCreator from './i18n/en/MealCreator.json';
import enMealImportModal from './i18n/en/MealImportModal.json';
import enCreateExercisePage from './i18n/en/CreateExercisePage.json';
import enQuestionnaireByTaskPage from './i18n/en/QuestionnaireByTaskPage.json';
import enEditQuestionnairesPage from './i18n/en/EditQuestionnairesPage.json';
import enSplashScreen from './i18n/en/SplashScreen.json';
import enWorkflowdocument from './i18n/en/Workflowdocument.json';
import enUseEditPatient from './i18n/en/UseEditPatient.json';
import enDocumentsPanel from './i18n/en/DocumentsPanel.json';
import enCaseViewPage from './i18n/en/CaseViewPage.json';
import enSearchPreRegisterPage from './i18n/en/SearchPreRegisterPage.json';
import enPreRegisterPatientSummaryPage from './i18n/en/PreRegisterPatientSummaryPage.json';
import enPublicPatientSummaryRoute from './i18n/en/PublicPatientSummaryRoute.json';
import enTasksPanel from './i18n/en/TasksPanel.json';
import enVideoTasksSection from './i18n/en/VideoTasksSection.json';
import enQuestionnaireWorkflowPage from './i18n/en/QuestionnaireWorkflowPage.json';
import enPractitionerDetailPage from './i18n/en/PractitionerDetailPage.json';
import enPreRegisterFAQPage from './i18n/en/PreRegisterFAQPage.json';
// --- German Imports ---
import deHeader from './i18n/de/Header.json';
import deShell from './i18n/de/ReactAppShell.json';
import deDashboard from './i18n/de/DashboardPage.json';
import deSearchPage from './i18n/de/SearchPage.json';
import deCaseView from './i18n/de/CaseView.json';
import deMessage from './i18n/de/Message.json';
import deSchedulePage from './i18n/de/SchedulePage.json';
import deAppointmentPage from './i18n/de/AppointmentPage.json';
import deDiseaseProgram from './i18n/de/DiseaseProgramsDashboardPage.json';
import deQuestionnairesPage from './i18n/de/QuestionnairesPage.json';
import deMediaPage from './i18n/de/Media.json';
import deDocumentDashboard from './i18n/de/DocumentDashboard.json';
import deMealPlanner from './i18n/de/MealPlanner.json';
import deOrganization from './i18n/de/OrganizationPage.json';
import deNews from './i18n/de/NewsDashboard.json';
import dePermission from './i18n/de/PermissionSettings.json';
import dePractitioner from './i18n/de/PractitionersPage.json';
import deOrganizational from './i18n/de/OrganizationalSchedules.json';
import deFormPanel from './i18n/de/FormPanel.json';
import deExerciseDashboardPage from './i18n/de/ExerciseDashboardPage.json';
import deClinicalSettingsPage from './i18n/de/ClinicalSettingsPage.json';
import deAdministrativeSettingsPage from './i18n/de/AdministrativeSettingsPage.json';
import deBillingSettingsPage from './i18n/de/BillingSettingsPage.json';
import deStep0Organization from './i18n/de/Step0Org.json';
import deStep1Categories from './i18n/de/Step1Categories.json';
import deChatWindow from './i18n/de/ChatWindow.json';
import deExternalSystemsSettings from './i18n/de/ExternalSystemsSettings.json';
import deOrganizationalSchedules from './i18n/de/OrganizationalSchedules.json';
import deCreateDiseaseProgramPage from './i18n/de/CreateDiseaseProgramPage.json';
import deAppointmentDetailPage from './i18n/de/AppointmentDetailPage.json';
import deAppointmentTasksPanel from './i18n/de/AppointmentTasksPanel.json';
import deOrdersSearchPage from './i18n/de/OrdersSearchPage.json';
import deOrderSearch from './i18n/de/OrderSearch.json';
import deAdminSettingsSections from './i18n/de/AdminSettingsSections.json';
import degenericSection from './i18n/de/genericSection.json';
import deExternalConfigurations from './i18n/de/ExternalConfigurations.json';
import deOrdersPage from './i18n/de/OrdersPage.json';
import deMedicationTab from './i18n/de/MedicationTab.json';
import deNotesVitalsTab from './i18n/de/NotesVitalsTab.json';
import deOrderComposer from './i18n/de/OrderComposer.json';
import deStepOrderSelector from './i18n/de/StepOrderSelector.json';
import deStepCaseAndDetails from './i18n/de/StepCaseAndDetails.json';
import deClinicalSettings from './i18n/de/ClinicalSettings.json';
import deCreateAppointmentPage from './i18n/de/CreateAppointmentPage.json';
import deStepTasks from './i18n/de/StepTasks.json';
import dePrevisitTasks from './i18n/de/PrevisitTasks.json';
import deNewPatientPage from './i18n/de/NewPatientPage.json';
import deAllergiesAndCases from './i18n/de/AllergiesAndCases.json';
import deBillingDashboardPage from './i18n/de/BillingDashboardPage.json';
import deBillingShell from './i18n/de/BillingShell.json';
import deEditPatientPage from './i18n/de/EditPatientPage.json';
import deImmunizationsSection from './i18n/de/ImmunizationsSection.json';
import deIdentitySection from './i18n/de/IdentitySection.json';
import deContactAddressSection from './i18n/de/ContactAddressSection.json';
import dePatientBasicsSection from './i18n/de/PatientBasicsSection.json';
import deCaseEdit from './i18n/de/CaseEdit.json';
import deCaseCaseSections from './i18n/de/CaseCaseSections.json';
import deImmunizationSection from './i18n/de/ImmunizationSection.json';
import deAllergySection from './i18n/de/AllergySection.json';
import deStepGeneralConfig from './i18n/de/StepGeneralConfig.json';
import dePreVisitTasks from './i18n/de/PrevisitTasks.json';
import dePatientSummaryPage from './i18n/de/PatientSummaryPage.json';
import deOverviewPanel from './i18n/de/OverviewPanel.json';
import deAllergiesPanel from './i18n/de/AllergiesPanel.json';
import dePatientHeader from './i18n/de/PatientHeader.json';
import deBedPlannerDashboard from './i18n/de/BedPlannerDashboard.json';
import deCreateDocumentModal from './i18n/de/CreateDocumentModal.json';
import deVideoForm from './i18n/de/VideoForm.json';
import deOrganizationSettings from './i18n/de/OrganizationSettings.json';
import deWorkflowDashboard from './i18n/de/WorkflowDashboard.json';
import deWorkflowCreate from './i18n/de/WorkflowCreate.json';
import deWorkflowTimeSavedSummary from './i18n/de/WorkflowTimeSavedSummary.json';
import deworkflowUtils from './i18n/de/workflowUtils.json';
import deTemplates from './i18n/de/Templates.json';
import deTemplateCreator from './i18n/de/TemplateCreator.json';
import deSharedPatientPage from './i18n/de/SharedPatientPage.json';
import dePdfViewer from './i18n/de/PdfViewer.json';
import deChargesListPage from './i18n/de/ChargesListPage.json';
import deAppointmentOverviewSplitSection from './i18n/de/AppointmentOverviewSplitSection.json';
import deLegalDocumentsPanel from './i18n/de/LegalDocumentsPanel.json';
import dePatientQuestionnairesPanel from './i18n/de/PatientQuestionnairesPanel.json';
import deAssignPatientQuestionnaire from './i18n/de/AssignPatientQuestionnaire.json';
import deCasesImmunizationsPanel from './i18n/de/CasesImmunizationsPanel.json';
import deStepDocuments from './i18n/de/StepDocuments.json';
import deStepReview from './i18n/de/StepReview.json';
import deAppointmentDetailMainSections from './i18n/de/AppointmentDetailMainSections.json';
import deAISummarySection from './i18n/de/AISummarySection.json';
import deClaimsListPage from './i18n/de/ClaimsListPage.json';
import deClaimEditorPage from './i18n/de/ClaimEditorPage.json';
import deReportsLightPage from './i18n/de/ReportsLightPage.json';
import deDenialsAppealsPage from './i18n/de/DenialsAppealsPage.json';
import deARWorklistsPage from './i18n/de/ARWorklistsPage.json';
import deEstimatesPage from './i18n/de/EstimatesPage.json';
import deStatementListPage from './i18n/de/StatementListPage.json';
import dePaymentsPage from './i18n/de/PaymentsPage.json';
import deChargeEditorPage from './i18n/de/ChargeEditorPage.json';
import deImpressum from './i18n/de/Impressum.json';
import deSignInPage from './i18n/de/SignInPage.json';
import deAppointmentsPanel from './i18n/de/AppointmentsPanel.json';
import deAppointmentNotesAndSummariesTab from './i18n/de/AppointmentNotesAndSummariesTab.json';
import dePatientInviteAction from './i18n/de/PatientInviteAction.json';
import deAssignProgramPage from './i18n/de/AssignProgramPage.json';
import deMealCreator from './i18n/de/MealCreator.json';
import deMealImportModal from './i18n/de/MealImportModal.json';
import deCreateExercisePage from './i18n/de/CreateExercisePage.json';
import deQuestionnaireByTaskPage from './i18n/de/QuestionnaireByTaskPage.json';
import deEditQuestionnairesPage from './i18n/de/EditQuestionnairesPage.json';
import deSplashScreen from './i18n/de/SplashScreen.json';
import deWorkflowdocument from './i18n/de/Workflowdocument.json';
import deUseEditPatient from './i18n/de/UseEditPatient.json';
import deDocumentsPanel from './i18n/de/DocumentsPanel.json';
import deCaseViewPage from './i18n/de/CaseViewPage.json';
import deSearchPreRegisterPage from './i18n/de/SearchPreRegisterPage.json';
import dePreRegisterPatientSummaryPage from './i18n/de/PreRegisterPatientSummaryPage.json';
import dePublicPatientSummaryRoute from './i18n/de/PublicPatientSummaryRoute.json';
import deTasksPanel from './i18n/de/TasksPanel.json';
import deVideoTasksSection from './i18n/de/VideoTasksSection.json';
import deQuestionnaireWorkflowPage from './i18n/de/QuestionnaireWorkflowPage.json';
import dePractitionerDetailPage from './i18n/de/PractitionerDetailPage.json';
import dePreRegisterFAQPage from './i18n/de/PreRegisterFAQPage.json';
// --- Arabic Imports ---
import arHeader from './i18n/ar/Header.json';
import arShell from './i18n/ar/ReactAppShell.json';
import arDashboard from './i18n/ar/DashboardPage.json';
import arSearchPage from './i18n/ar/SearchPage.json';
import arCaseView from './i18n/ar/CaseView.json';
import arMessage from './i18n/ar/Message.json';
import arSchedulePage from './i18n/ar/SchedulePage.json';
import arAppointmentPage from './i18n/ar/AppointmentPage.json';
import arDiseaseProgram from './i18n/ar/DiseaseProgramsDashboardPage.json';
import arQuestionnairesPage from './i18n/ar/QuestionnairesPage.json';
import arMediaPage from './i18n/ar/Media.json';
import arDocumentDashboard from './i18n/ar/DocumentDashboard.json';
import arMealPlanner from './i18n/ar/MealPlanner.json';
import arOrganization from './i18n/ar/OrganizationPage.json';
import arNews from './i18n/ar/NewsDashboard.json';
import arPermission from './i18n/ar/PermissionSettings.json';
import arPractitioner from './i18n/ar/PractitionersPage.json';
import arOrganizational from './i18n/ar/OrganizationalSchedules.json';
import arFormPanel from './i18n/ar/FormPanel.json';
import arExerciseDashboardPage from './i18n/ar/ExerciseDashboardPage.json';
import arClinicalSettingsPage from './i18n/ar/ClinicalSettingsPage.json';
import arAdministrativeSettingsPage from './i18n/ar/AdministrativeSettingsPage.json';
import arBillingSettingsPage from './i18n/ar/BillingSettingsPage.json';
import arStep0Organization from './i18n/ar/Step0Org.json';
import arStep1Categories from './i18n/ar/Step1Categories.json';
import arChatWindow from './i18n/ar/ChatWindow.json';
import arExternalSystemsSettings from './i18n/ar/ExternalSystemsSettings.json';
import arOrganizationalSchedules from './i18n/ar/OrganizationalSchedules.json';
import arCreateDiseaseProgramPage from './i18n/ar/CreateDiseaseProgramPage.json';
import arAppointmentDetailPage from './i18n/ar/AppointmentDetailPage.json';
import arAppointmentTasksPanel from './i18n/ar/AppointmentTasksPanel.json';
import arOrdersSearchPage from './i18n/ar/OrdersSearchPage.json';
import arOrderSearch from './i18n/ar/OrderSearch.json';
import arAdminSettingsSections from './i18n/ar/AdminSettingsSections.json';
import argenericSection from './i18n/ar/genericSection.json';
import arExternalConfigurations from './i18n/ar/ExternalConfigurations.json';
import arOrdersPage from './i18n/ar/OrdersPage.json';
import arMedicationTab from './i18n/ar/MedicationTab.json';
import arNotesVitalsTab from './i18n/ar/NotesVitalsTab.json';
import arOrderComposer from './i18n/ar/OrderComposer.json';
import arStepOrderSelector from './i18n/ar/StepOrderSelector.json';
import arStepCaseAndDetails from './i18n/ar/StepCaseAndDetails.json';
import arClinicalSettings from './i18n/ar/ClinicalSettings.json';
import arCreateAppointmentPage from './i18n/ar/CreateAppointmentPage.json';
import arStepTasks from './i18n/ar/StepTasks.json';
import arPrevisitTasks from './i18n/ar/PrevisitTasks.json';
import arNewPatientPage from './i18n/ar/NewPatientPage.json';
import arAllergiesAndCases from './i18n/ar/AllergiesAndCases.json';
import arBillingDashboardPage from './i18n/ar/BillingDashboardPage.json';
import arBillingShell from './i18n/ar/BillingShell.json';
import arEditPatientPage from './i18n/ar/EditPatientPage.json';
import arImmunizationsSection from './i18n/ar/ImmunizationsSection.json';
import arIdentitySection from './i18n/ar/IdentitySection.json';
import arContactAddressSection from './i18n/ar/ContactAddressSection.json';
import arPatientBasicsSection from './i18n/ar/PatientBasicsSection.json';
import arCaseEdit from './i18n/ar/CaseEdit.json';
import arCaseCaseSections from './i18n/ar/CaseCaseSections.json';
import arImmunizationSection from './i18n/ar/ImmunizationSection.json';
import arAllergySection from './i18n/ar/AllergySection.json';
import arStepGeneralConfig from './i18n/ar/StepGeneralConfig.json';
import arPreVisitTasks from './i18n/ar/PrevisitTasks.json';
import arPatientSummaryPage from './i18n/ar/PatientSummaryPage.json';
import arOverviewPanel from './i18n/ar/OverviewPanel.json';
import arAllergiesPanel from './i18n/ar/AllergiesPanel.json';
import arPatientHeader from './i18n/ar/PatientHeader.json';
import arBedPlannerDashboard from './i18n/ar/BedPlannerDashboard.json';
import arCreateDocumentModal from './i18n/ar/CreateDocumentModal.json';
import arVideoForm from './i18n/ar/VideoForm.json';
import arOrganizationSettings from './i18n/ar/OrganizationSettings.json';
import arWorkflowDashboard from './i18n/ar/WorkflowDashboard.json';
import arWorkflowCreate from './i18n/ar/WorkflowCreate.json';
import arWorkflowTimeSavedSummary from './i18n/ar/WorkflowTimeSavedSummary.json';
import arworkflowUtils from './i18n/ar/workflowUtils.json';
import arTemplates from './i18n/ar/Templates.json';
import arTemplateCreator from './i18n/ar/TemplateCreator.json';
import arSharedPatientPage from './i18n/ar/SharedPatientPage.json';
import arPdfViewer from './i18n/ar/PdfViewer.json';
import arChargesListPage from './i18n/ar/ChargesListPage.json';
import arAppointmentOverviewSplitSection from './i18n/ar/AppointmentOverviewSplitSection.json';
import arLegalDocumentsPanel from './i18n/ar/LegalDocumentsPanel.json';
import arPatientQuestionnairesPanel from './i18n/ar/PatientQuestionnairesPanel.json';
import arAssignPatientQuestionnaire from './i18n/ar/AssignPatientQuestionnaire.json';
import arCasesImmunizationsPanel from './i18n/ar/CasesImmunizationsPanel.json';
import arStepDocuments from './i18n/ar/StepDocuments.json';
import arStepReview from './i18n/ar/StepReview.json';
import arAppointmentDetailMainSections from './i18n/ar/AppointmentDetailMainSections.json';
import arAISummarySection from './i18n/ar/AISummarySection.json';
import arClaimsListPage from './i18n/ar/ClaimsListPage.json';
import arClaimEditorPage from './i18n/ar/ClaimEditorPage.json';
import arReportsLightPage from './i18n/ar/ReportsLightPage.json';
import arDenialsAppealsPage from './i18n/ar/DenialsAppealsPage.json';
import arARWorklistsPage from './i18n/ar/ARWorklistsPage.json';
import arEstimatesPage from './i18n/ar/EstimatesPage.json';
import arStatementListPage from './i18n/ar/StatementListPage.json';
import arPaymentsPage from './i18n/ar/PaymentsPage.json';
import arChargeEditorPage from './i18n/ar/ChargeEditorPage.json';
import arImpressum from './i18n/ar/Impressum.json';
import arSignInPage from './i18n/ar/SignInPage.json';
import arAppointmentsPanel from './i18n/ar/AppointmentsPanel.json';
import arAppointmentNotesAndSummariesTab from './i18n/ar/AppointmentNotesAndSummariesTab.json';
import arPatientInviteAction from './i18n/ar/PatientInviteAction.json';
import arAssignProgramPage from './i18n/ar/AssignProgramPage.json';
import arMealCreator from './i18n/ar/MealCreator.json';
import arMealImportModal from './i18n/ar/MealImportModal.json';
import arCreateExercisePage from './i18n/ar/CreateExercisePage.json';
import arQuestionnaireByTaskPage from './i18n/ar/QuestionnaireByTaskPage.json';
import arEditQuestionnairesPage from './i18n/ar/EditQuestionnairesPage.json';
import arSplashScreen from './i18n/ar/SplashScreen.json';
import arWorkflowdocument from './i18n/ar/Workflowdocument.json';
import arUseEditPatient from './i18n/ar/UseEditPatient.json';
import arDocumentsPanel from './i18n/ar/DocumentsPanel.json';
import arCaseViewPage from './i18n/ar/CaseViewPage.json';
import arSearchPreRegisterPage from './i18n/ar/SearchPreRegisterPage.json';
import arPreRegisterPatientSummaryPage from './i18n/ar/PreRegisterPatientSummaryPage.json';
import arPublicPatientSummaryRoute from './i18n/ar/PublicPatientSummaryRoute.json';
import arTasksPanel from './i18n/ar/TasksPanel.json';
import arVideoTasksSection from './i18n/ar/VideoTasksSection.json';
import arQuestionnaireWorkflowPage from './i18n/ar/QuestionnaireWorkflowPage.json';
import arPractitionerDetailPage from './i18n/ar/PractitionerDetailPage.json';
import arPreRegisterFAQPage from './i18n/ar/PreRegisterFAQPage.json';

import esHeader from './i18n/es/Header.json';
import esShell from './i18n/es/ReactAppShell.json';
import esDashboard from './i18n/es/DashboardPage.json';
import esSearchPage from './i18n/es/SearchPage.json';
import esCaseView from './i18n/es/CaseView.json';
import esMessage from './i18n/es/Message.json';
import esSchedulePage from './i18n/es/SchedulePage.json';
import esAppointmentPage from './i18n/es/AppointmentPage.json';
import esDiseaseProgram from './i18n/es/DiseaseProgramsDashboardPage.json';
import esQuestionnairesPage from './i18n/es/QuestionnairesPage.json';
import esMediaPage from './i18n/es/Media.json';
import esDocumentDashboard from './i18n/es/DocumentDashboard.json';
import esMealPlanner from './i18n/es/MealPlanner.json';
import esOrganization from './i18n/es/OrganizationPage.json';
import esNews from './i18n/es/NewsDashboard.json';
import esPermission from './i18n/es/PermissionSettings.json';
import esPractitioner from './i18n/es/PractitionersPage.json';
import esOrganizational from './i18n/es/OrganizationalSchedules.json';
import esFormPanel from './i18n/es/FormPanel.json';
import esExerciseDashboardPage from './i18n/es/ExerciseDashboardPage.json';
import esClinicalSettingsPage from './i18n/es/ClinicalSettingsPage.json';
import esAdministrativeSettingsPage from './i18n/es/AdministrativeSettingsPage.json';
import esBillingSettingsPage from './i18n/es/BillingSettingsPage.json';
import esStep0Organization from './i18n/es/Step0Org.json';
import esStep1Categories from './i18n/es/Step1Categories.json';
import esChatWindow from './i18n/es/ChatWindow.json';
import esExternalSystemsSettings from './i18n/es/ExternalSystemsSettings.json';
import esOrganizationalSchedules from './i18n/es/OrganizationalSchedules.json';
import esCreateDiseaseProgramPage from './i18n/es/CreateDiseaseProgramPage.json';
import esAppointmentDetailPage from './i18n/es/AppointmentDetailPage.json';
import esAppointmentTasksPanel from './i18n/es/AppointmentTasksPanel.json';
import esOrdersSearchPage from './i18n/es/OrdersSearchPage.json';
import esOrderSearch from './i18n/es/OrderSearch.json';
import esAdminSettingsSections from './i18n/es/AdminSettingsSections.json';
import esgenericSection from './i18n/es/genericSection.json';
import esExternalConfigurations from './i18n/es/ExternalConfigurations.json';
import esOrdersPage from './i18n/es/OrdersPage.json';
import esMedicationTab from './i18n/es/MedicationTab.json';
import esNotesVitalsTab from './i18n/es/NotesVitalsTab.json';
import esOrderComposer from './i18n/es/OrderComposer.json';
import esStepOrderSelector from './i18n/es/StepOrderSelector.json';
import esStepCaseAndDetails from './i18n/es/StepCaseAndDetails.json';
import esClinicalSettings from './i18n/es/ClinicalSettings.json';
import esCreateAppointmentPage from './i18n/es/CreateAppointmentPage.json';
import esStepTasks from './i18n/es/StepTasks.json';
import esPrevisitTasks from './i18n/es/PrevisitTasks.json';
import esNewPatientPage from './i18n/es/NewPatientPage.json';
import esAllergiesAndCases from './i18n/es/AllergiesAndCases.json';
import esBillingDashboardPage from './i18n/es/BillingDashboardPage.json';
import esBillingShell from './i18n/es/BillingShell.json';
import esEditPatientPage from './i18n/es/EditPatientPage.json';
import esImmunizationsSection from './i18n/es/ImmunizationsSection.json';
import esIdentitySection from './i18n/es/IdentitySection.json';
import esContactAddressSection from './i18n/es/ContactAddressSection.json';
import esPatientBasicsSection from './i18n/es/PatientBasicsSection.json';
import esCaseEdit from './i18n/es/CaseEdit.json';
import esCaseCaseSections from './i18n/es/CaseCaseSections.json';
import esImmunizationSection from './i18n/es/ImmunizationSection.json';
import esAllergySection from './i18n/es/AllergySection.json';
import esStepGeneralConfig from './i18n/es/StepGeneralConfig.json';
import esPreVisitTasks from './i18n/es/PrevisitTasks.json';
import esPatientSummaryPage from './i18n/es/PatientSummaryPage.json';
import esOverviewPanel from './i18n/es/OverviewPanel.json';
import esAllergiesPanel from './i18n/es/AllergiesPanel.json';
import esPatientHeader from './i18n/es/PatientHeader.json';
import esBedPlannerDashboard from './i18n/es/BedPlannerDashboard.json';
import esCreateDocumentModal from './i18n/es/CreateDocumentModal.json';
import esVideoForm from './i18n/es/VideoForm.json';
import esOrganizationSettings from './i18n/es/OrganizationSettings.json';
import esWorkflowDashboard from './i18n/es/WorkflowDashboard.json';
import esWorkflowCreate from './i18n/es/WorkflowCreate.json';
import esWorkflowTimeSavedSummary from './i18n/es/WorkflowTimeSavedSummary.json';
import esworkflowUtils from './i18n/es/workflowUtils.json';
import esTemplates from './i18n/es/Templates.json';
import esTemplateCreator from './i18n/es/TemplateCreator.json';
import esSharedPatientPage from './i18n/es/SharedPatientPage.json';
import esPdfViewer from './i18n/es/PdfViewer.json';
import esChargesListPage from './i18n/es/ChargesListPage.json';
import esAppointmentOverviewSplitSection from './i18n/es/AppointmentOverviewSplitSection.json';
import esLegalDocumentsPanel from './i18n/es/LegalDocumentsPanel.json';
import esPatientQuestionnairesPanel from './i18n/es/PatientQuestionnairesPanel.json';
import esAssignPatientQuestionnaire from './i18n/es/AssignPatientQuestionnaire.json';
import esCasesImmunizationsPanel from './i18n/es/CasesImmunizationsPanel.json';
import esStepDocuments from './i18n/es/StepDocuments.json';
import esStepReview from './i18n/es/StepReview.json';
import esAppointmentDetailMainSections from './i18n/es/AppointmentDetailMainSections.json';
import esAISummarySection from './i18n/es/AISummarySection.json';
import esClaimsListPage from './i18n/es/ClaimsListPage.json';
import esClaimEditorPage from './i18n/es/ClaimEditorPage.json';
import esReportsLightPage from './i18n/es/ReportsLightPage.json';
import esDenialsAppealsPage from './i18n/es/DenialsAppealsPage.json';
import esARWorklistsPage from './i18n/es/ARWorklistsPage.json';
import esEstimatesPage from './i18n/es/EstimatesPage.json';
import esStatementListPage from './i18n/es/StatementListPage.json';
import esPaymentsPage from './i18n/es/PaymentsPage.json';
import esChargeEditorPage from './i18n/es/ChargeEditorPage.json';
import esImpressum from './i18n/es/Impressum.json';
import esSignInPage from './i18n/es/SignInPage.json';
import esAppointmentsPanel from './i18n/es/AppointmentsPanel.json';
import esAppointmentNotesAndSummariesTab from './i18n/es/AppointmentNotesAndSummariesTab.json';
import esPatientInviteAction from './i18n/es/PatientInviteAction.json';
import esAssignProgramPage from './i18n/es/AssignProgramPage.json';
import esMealCreator from './i18n/es/MealCreator.json';
import esMealImportModal from './i18n/es/MealImportModal.json';
import esCreateExercisePage from './i18n/es/CreateExercisePage.json';
import esQuestionnaireByTaskPage from './i18n/es/QuestionnaireByTaskPage.json';
import esEditQuestionnairesPage from './i18n/es/EditQuestionnairesPage.json';
import esSplashScreen from './i18n/es/SplashScreen.json';
import esWorkflowdocument from './i18n/es/Workflowdocument.json';
import esUseEditPatient from './i18n/es/UseEditPatient.json';
import esDocumentsPanel from './i18n/es/DocumentsPanel.json';
import esCaseViewPage from './i18n/es/CaseViewPage.json';
import esSearchPreRegisterPage from './i18n/es/SearchPreRegisterPage.json';
import esPreRegisterPatientSummaryPage from './i18n/es/PreRegisterPatientSummaryPage.json';
import esPublicPatientSummaryRoute from './i18n/es/PublicPatientSummaryRoute.json';
import esTasksPanel from './i18n/es/TasksPanel.json';
import esVideoTasksSection from './i18n/es/VideoTasksSection.json';
import esQuestionnaireWorkflowPage from './i18n/es/QuestionnaireWorkflowPage.json';
import esPractitionerDetailPage from './i18n/es/PractitionerDetailPage.json';
import esPreRegisterFAQPage from './i18n/es/PreRegisterFAQPage.json';

import frHeader from './i18n/fr/Header.json';
import frShell from './i18n/fr/ReactAppShell.json';
import frDashboard from './i18n/fr/DashboardPage.json';
import frSearchPage from './i18n/fr/SearchPage.json';
import frCaseView from './i18n/fr/CaseView.json';
import frMessage from './i18n/fr/Message.json';
import frSchedulePage from './i18n/fr/SchedulePage.json';
import frAppointmentPage from './i18n/fr/AppointmentPage.json';
import frDiseaseProgram from './i18n/fr/DiseaseProgramsDashboardPage.json';
import frQuestionnairesPage from './i18n/fr/QuestionnairesPage.json';
import frMediaPage from './i18n/fr/Media.json';
import frDocumentDashboard from './i18n/fr/DocumentDashboard.json';
import frMealPlanner from './i18n/fr/MealPlanner.json';
import frOrganization from './i18n/fr/OrganizationPage.json';
import frNews from './i18n/fr/NewsDashboard.json';
import frPermission from './i18n/fr/PermissionSettings.json';
import frPractitioner from './i18n/fr/PractitionersPage.json';
import frOrganizational from './i18n/fr/OrganizationalSchedules.json';
import frFormPanel from './i18n/fr/FormPanel.json';
import frExerciseDashboardPage from './i18n/fr/ExerciseDashboardPage.json';
import frClinicalSettingsPage from './i18n/fr/ClinicalSettingsPage.json';
import frAdministrativeSettingsPage from './i18n/fr/AdministrativeSettingsPage.json';
import frBillingSettingsPage from './i18n/fr/BillingSettingsPage.json';
import frStep0Organization from './i18n/fr/Step0Org.json';
import frStep1Categories from './i18n/fr/Step1Categories.json';
import frChatWindow from './i18n/fr/ChatWindow.json';
import frExternalSystemsSettings from './i18n/fr/ExternalSystemsSettings.json';
import frOrganizationalSchedules from './i18n/fr/OrganizationalSchedules.json';
import frCreateDiseaseProgramPage from './i18n/fr/CreateDiseaseProgramPage.json';
import frAppointmentDetailPage from './i18n/fr/AppointmentDetailPage.json';
import frAppointmentTasksPanel from './i18n/fr/AppointmentTasksPanel.json';
import frOrdersSearchPage from './i18n/fr/OrdersSearchPage.json';
import frOrderSearch from './i18n/fr/OrderSearch.json';
import frAdminSettingsSections from './i18n/fr/AdminSettingsSections.json';
import frgenericSection from './i18n/fr/genericSection.json';
import frExternalConfigurations from './i18n/fr/ExternalConfigurations.json';
import frOrdersPage from './i18n/fr/OrdersPage.json';
import frMedicationTab from './i18n/fr/MedicationTab.json';
import frNotesVitalsTab from './i18n/fr/NotesVitalsTab.json';
import frOrderComposer from './i18n/fr/OrderComposer.json';
import frStepOrderSelector from './i18n/fr/StepOrderSelector.json';
import frStepCaseAndDetails from './i18n/fr/StepCaseAndDetails.json';
import frClinicalSettings from './i18n/fr/ClinicalSettings.json';
import frCreateAppointmentPage from './i18n/fr/CreateAppointmentPage.json';
import frStepTasks from './i18n/fr/StepTasks.json';
import frPrevisitTasks from './i18n/fr/PrevisitTasks.json';
import frNewPatientPage from './i18n/fr/NewPatientPage.json';
import frAllergiesAndCases from './i18n/fr/AllergiesAndCases.json';
import frBillingDashboardPage from './i18n/fr/BillingDashboardPage.json';
import frBillingShell from './i18n/fr/BillingShell.json';
import frEditPatientPage from './i18n/fr/EditPatientPage.json';
import frImmunizationsSection from './i18n/fr/ImmunizationsSection.json';
import frIdentitySection from './i18n/fr/IdentitySection.json';
import frContactAddressSection from './i18n/fr/ContactAddressSection.json';
import frPatientBasicsSection from './i18n/fr/PatientBasicsSection.json';
import frCaseEdit from './i18n/fr/CaseEdit.json';
import frCaseCaseSections from './i18n/fr/CaseCaseSections.json';
import frImmunizationSection from './i18n/fr/ImmunizationSection.json';
import frAllergySection from './i18n/fr/AllergySection.json';
import frStepGeneralConfig from './i18n/fr/StepGeneralConfig.json';
import frPreVisitTasks from './i18n/fr/PrevisitTasks.json';
import frPatientSummaryPage from './i18n/fr/PatientSummaryPage.json';
import frOverviewPanel from './i18n/fr/OverviewPanel.json';
import frAllergiesPanel from './i18n/fr/AllergiesPanel.json';
import frPatientHeader from './i18n/fr/PatientHeader.json';
import frBedPlannerDashboard from './i18n/fr/BedPlannerDashboard.json';
import frCreateDocumentModal from './i18n/fr/CreateDocumentModal.json';
import frVideoForm from './i18n/fr/VideoForm.json';
import frOrganizationSettings from './i18n/fr/OrganizationSettings.json';
import frWorkflowDashboard from './i18n/fr/WorkflowDashboard.json';
import frWorkflowCreate from './i18n/fr/WorkflowCreate.json';
import frWorkflowTimeSavedSummary from './i18n/fr/WorkflowTimeSavedSummary.json';
import frworkflowUtils from './i18n/fr/workflowUtils.json';
import frTemplates from './i18n/fr/Templates.json';
import frTemplateCreator from './i18n/fr/TemplateCreator.json';
import frSharedPatientPage from './i18n/fr/SharedPatientPage.json';
import frPdfViewer from './i18n/fr/PdfViewer.json';
import frChargesListPage from './i18n/fr/ChargesListPage.json';
import frAppointmentOverviewSplitSection from './i18n/fr/AppointmentOverviewSplitSection.json';
import frLegalDocumentsPanel from './i18n/fr/LegalDocumentsPanel.json';
import frPatientQuestionnairesPanel from './i18n/fr/PatientQuestionnairesPanel.json';
import frAssignPatientQuestionnaire from './i18n/fr/AssignPatientQuestionnaire.json';
import frCasesImmunizationsPanel from './i18n/fr/CasesImmunizationsPanel.json';
import frStepDocuments from './i18n/fr/StepDocuments.json';
import frStepReview from './i18n/fr/StepReview.json';
import frAppointmentDetailMainSections from './i18n/fr/AppointmentDetailMainSections.json';
import frAISummarySection from './i18n/fr/AISummarySection.json';
import frClaimsListPage from './i18n/fr/ClaimsListPage.json';
import frClaimEditorPage from './i18n/fr/ClaimEditorPage.json';
import frReportsLightPage from './i18n/fr/ReportsLightPage.json';
import frDenialsAppealsPage from './i18n/fr/DenialsAppealsPage.json';
import frARWorklistsPage from './i18n/fr/ARWorklistsPage.json';
import frEstimatesPage from './i18n/fr/EstimatesPage.json';
import frStatementListPage from './i18n/fr/StatementListPage.json';
import frPaymentsPage from './i18n/fr/PaymentsPage.json';
import frChargeEditorPage from './i18n/fr/ChargeEditorPage.json';
import frImpressum from './i18n/fr/Impressum.json';
import frSignInPage from './i18n/fr/SignInPage.json';
import frAppointmentsPanel from './i18n/fr/AppointmentsPanel.json';
import frAppointmentNotesAndSummariesTab from './i18n/fr/AppointmentNotesAndSummariesTab.json';
import frPatientInviteAction from './i18n/fr/PatientInviteAction.json';
import frAssignProgramPage from './i18n/fr/AssignProgramPage.json';
import frMealCreator from './i18n/fr/MealCreator.json';
import frMealImportModal from './i18n/fr/MealImportModal.json';
import frCreateExercisePage from './i18n/fr/CreateExercisePage.json';
import frQuestionnaireByTaskPage from './i18n/fr/QuestionnaireByTaskPage.json';
import frEditQuestionnairesPage from './i18n/fr/EditQuestionnairesPage.json';
import frSplashScreen from './i18n/fr/SplashScreen.json';
import frWorkflowdocument from './i18n/fr/Workflowdocument.json';
import frUseEditPatient from './i18n/fr/UseEditPatient.json';
import frDocumentsPanel from './i18n/fr/DocumentsPanel.json';
import frCaseViewPage from './i18n/fr/CaseViewPage.json';
import frSearchPreRegisterPage from './i18n/fr/SearchPreRegisterPage.json';
import frPreRegisterPatientSummaryPage from './i18n/fr/PreRegisterPatientSummaryPage.json';
import frPublicPatientSummaryRoute from './i18n/fr/PublicPatientSummaryRoute.json';
import frTasksPanel from './i18n/fr/TasksPanel.json';
import frVideoTasksSection from './i18n/fr/VideoTasksSection.json';
import frQuestionnaireWorkflowPage from './i18n/fr/QuestionnaireWorkflowPage.json';
import frPractitionerDetailPage from './i18n/fr/PractitionerDetailPage.json';
import frPreRegisterFAQPage from './i18n/fr/PreRegisterFAQPage.json';

import itHeader from './i18n/it/Header.json';
import itShell from './i18n/it/ReactAppShell.json';
import itDashboard from './i18n/it/DashboardPage.json';
import itSearchPage from './i18n/it/SearchPage.json';
import itCaseView from './i18n/it/CaseView.json';
import itMessage from './i18n/it/Message.json';
import itSchedulePage from './i18n/it/SchedulePage.json';
import itAppointmentPage from './i18n/it/AppointmentPage.json';
import itDiseaseProgram from './i18n/it/DiseaseProgramsDashboardPage.json';
import itQuestionnairesPage from './i18n/it/QuestionnairesPage.json';
import itMediaPage from './i18n/it/Media.json';
import itDocumentDashboard from './i18n/it/DocumentDashboard.json';
import itMealPlanner from './i18n/it/MealPlanner.json';
import itOrganization from './i18n/it/OrganizationPage.json';
import itNews from './i18n/it/NewsDashboard.json';
import itPermission from './i18n/it/PermissionSettings.json';
import itPractitioner from './i18n/it/PractitionersPage.json';
import itOrganizational from './i18n/it/OrganizationalSchedules.json';
import itFormPanel from './i18n/it/FormPanel.json';
import itExerciseDashboardPage from './i18n/it/ExerciseDashboardPage.json';
import itClinicalSettingsPage from './i18n/it/ClinicalSettingsPage.json';
import itAdministrativeSettingsPage from './i18n/it/AdministrativeSettingsPage.json';
import itBillingSettingsPage from './i18n/it/BillingSettingsPage.json';
import itStep0Organization from './i18n/it/Step0Org.json';
import itStep1Categories from './i18n/it/Step1Categories.json';
import itChatWindow from './i18n/it/ChatWindow.json';
import itExternalSystemsSettings from './i18n/it/ExternalSystemsSettings.json';
import itOrganizationalSchedules from './i18n/it/OrganizationalSchedules.json';
import itCreateDiseaseProgramPage from './i18n/it/CreateDiseaseProgramPage.json';
import itAppointmentDetailPage from './i18n/it/AppointmentDetailPage.json';
import itAppointmentTasksPanel from './i18n/it/AppointmentTasksPanel.json';
import itOrdersSearchPage from './i18n/it/OrdersSearchPage.json';
import itOrderSearch from './i18n/it/OrderSearch.json';
import itAdminSettingsSections from './i18n/it/AdminSettingsSections.json';
import itgenericSection from './i18n/it/genericSection.json';
import itExternalConfigurations from './i18n/it/ExternalConfigurations.json';
import itOrdersPage from './i18n/it/OrdersPage.json';
import itMedicationTab from './i18n/it/MedicationTab.json';
import itNotesVitalsTab from './i18n/it/NotesVitalsTab.json';
import itOrderComposer from './i18n/it/OrderComposer.json';
import itStepOrderSelector from './i18n/it/StepOrderSelector.json';
import itStepCaseAndDetails from './i18n/it/StepCaseAndDetails.json';
import itClinicalSettings from './i18n/it/ClinicalSettings.json';
import itCreateAppointmentPage from './i18n/it/CreateAppointmentPage.json';
import itStepTasks from './i18n/it/StepTasks.json';
import itPrevisitTasks from './i18n/it/PrevisitTasks.json';
import itNewPatientPage from './i18n/it/NewPatientPage.json';
import itAllergiesAndCases from './i18n/it/AllergiesAndCases.json';
import itBillingDashboardPage from './i18n/it/BillingDashboardPage.json';
import itBillingShell from './i18n/it/BillingShell.json';
import itEditPatientPage from './i18n/it/EditPatientPage.json';
import itImmunizationsSection from './i18n/it/ImmunizationsSection.json';
import itIdentitySection from './i18n/it/IdentitySection.json';
import itContactAddressSection from './i18n/it/ContactAddressSection.json';
import itPatientBasicsSection from './i18n/it/PatientBasicsSection.json';
import itCaseEdit from './i18n/it/CaseEdit.json';
import itCaseCaseSections from './i18n/it/CaseCaseSections.json';
import itImmunizationSection from './i18n/it/ImmunizationSection.json';
import itAllergySection from './i18n/it/AllergySection.json';
import itStepGeneralConfig from './i18n/it/StepGeneralConfig.json';
import itPreVisitTasks from './i18n/it/PrevisitTasks.json';
import itPatientSummaryPage from './i18n/it/PatientSummaryPage.json';
import itOverviewPanel from './i18n/it/OverviewPanel.json';
import itAllergiesPanel from './i18n/it/AllergiesPanel.json';
import itPatientHeader from './i18n/it/PatientHeader.json';
import itBedPlannerDashboard from './i18n/it/BedPlannerDashboard.json';
import itCreateDocumentModal from './i18n/it/CreateDocumentModal.json';
import itVideoForm from './i18n/it/VideoForm.json';
import itOrganizationSettings from './i18n/it/OrganizationSettings.json';
import itWorkflowDashboard from './i18n/it/WorkflowDashboard.json';
import itWorkflowCreate from './i18n/it/WorkflowCreate.json';
import itWorkflowTimeSavedSummary from './i18n/it/WorkflowTimeSavedSummary.json';
import itworkflowUtils from './i18n/it/workflowUtils.json';
import itTemplates from './i18n/it/Templates.json';
import itTemplateCreator from './i18n/it/TemplateCreator.json';
import itSharedPatientPage from './i18n/it/SharedPatientPage.json';
import itPdfViewer from './i18n/it/PdfViewer.json';
import itChargesListPage from './i18n/it/ChargesListPage.json';
import itAppointmentOverviewSplitSection from './i18n/it/AppointmentOverviewSplitSection.json';
import itLegalDocumentsPanel from './i18n/it/LegalDocumentsPanel.json';
import itPatientQuestionnairesPanel from './i18n/it/PatientQuestionnairesPanel.json';
import itAssignPatientQuestionnaire from './i18n/it/AssignPatientQuestionnaire.json';
import itCasesImmunizationsPanel from './i18n/it/CasesImmunizationsPanel.json';
import itStepDocuments from './i18n/it/StepDocuments.json';
import itStepReview from './i18n/it/StepReview.json';
import itAppointmentDetailMainSections from './i18n/it/AppointmentDetailMainSections.json';
import itAISummarySection from './i18n/it/AISummarySection.json';
import itClaimsListPage from './i18n/it/ClaimsListPage.json';
import itClaimEditorPage from './i18n/it/ClaimEditorPage.json';
import itReportsLightPage from './i18n/it/ReportsLightPage.json';
import itDenialsAppealsPage from './i18n/it/DenialsAppealsPage.json';
import itARWorklistsPage from './i18n/it/ARWorklistsPage.json';
import itEstimatesPage from './i18n/it/EstimatesPage.json';
import itStatementListPage from './i18n/it/StatementListPage.json';
import itPaymentsPage from './i18n/it/PaymentsPage.json';
import itChargeEditorPage from './i18n/it/ChargeEditorPage.json';
import itImpressum from './i18n/it/Impressum.json';
import itSignInPage from './i18n/it/SignInPage.json';
import itAppointmentsPanel from './i18n/it/AppointmentsPanel.json';
import itAppointmentNotesAndSummariesTab from './i18n/it/AppointmentNotesAndSummariesTab.json';
import itPatientInviteAction from './i18n/it/PatientInviteAction.json';
import itAssignProgramPage from './i18n/it/AssignProgramPage.json';
import itMealCreator from './i18n/it/MealCreator.json';
import itMealImportModal from './i18n/it/MealImportModal.json';
import itCreateExercisePage from './i18n/it/CreateExercisePage.json';
import itQuestionnaireByTaskPage from './i18n/it/QuestionnaireByTaskPage.json';
import itEditQuestionnairesPage from './i18n/it/EditQuestionnairesPage.json';
import itSplashScreen from './i18n/it/SplashScreen.json';
import itWorkflowdocument from './i18n/it/Workflowdocument.json';
import itUseEditPatient from './i18n/it/UseEditPatient.json';
import itDocumentsPanel from './i18n/it/DocumentsPanel.json';
import itCaseViewPage from './i18n/it/CaseViewPage.json';
import itSearchPreRegisterPage from './i18n/it/SearchPreRegisterPage.json';
import itPreRegisterPatientSummaryPage from './i18n/it/PreRegisterPatientSummaryPage.json';
import itPublicPatientSummaryRoute from './i18n/it/PublicPatientSummaryRoute.json';
import itTasksPanel from './i18n/it/TasksPanel.json';
import itVideoTasksSection from './i18n/it/VideoTasksSection.json';
import itQuestionnaireWorkflowPage from './i18n/it/QuestionnaireWorkflowPage.json';
import itPractitionerDetailPage from './i18n/it/PractitionerDetailPage.json';
import itPreRegisterFAQPage from './i18n/it/PreRegisterFAQPage.json';

import nlHeader from './i18n/nl/Header.json';
import nlShell from './i18n/nl/ReactAppShell.json';
import nlDashboard from './i18n/nl/DashboardPage.json';
import nlSearchPage from './i18n/nl/SearchPage.json';
import nlCaseView from './i18n/nl/CaseView.json';
import nlMessage from './i18n/nl/Message.json';
import nlSchedulePage from './i18n/nl/SchedulePage.json';
import nlAppointmentPage from './i18n/nl/AppointmentPage.json';
import nlDiseaseProgram from './i18n/nl/DiseaseProgramsDashboardPage.json';
import nlQuestionnairesPage from './i18n/nl/QuestionnairesPage.json';
import nlMediaPage from './i18n/nl/Media.json';
import nlDocumentDashboard from './i18n/nl/DocumentDashboard.json';
import nlMealPlanner from './i18n/nl/MealPlanner.json';
import nlOrganization from './i18n/nl/OrganizationPage.json';
import nlNews from './i18n/nl/NewsDashboard.json';
import nlPermission from './i18n/nl/PermissionSettings.json';
import nlPractitioner from './i18n/nl/PractitionersPage.json';
import nlOrganizational from './i18n/nl/OrganizationalSchedules.json';
import nlFormPanel from './i18n/nl/FormPanel.json';
import nlExerciseDashboardPage from './i18n/nl/ExerciseDashboardPage.json';
import nlClinicalSettingsPage from './i18n/nl/ClinicalSettingsPage.json';
import nlAdministrativeSettingsPage from './i18n/nl/AdministrativeSettingsPage.json';
import nlBillingSettingsPage from './i18n/nl/BillingSettingsPage.json';
import nlStep0Organization from './i18n/nl/Step0Org.json';
import nlStep1Categories from './i18n/nl/Step1Categories.json';
import nlChatWindow from './i18n/nl/ChatWindow.json';
import nlExternalSystemsSettings from './i18n/nl/ExternalSystemsSettings.json';
import nlOrganizationalSchedules from './i18n/nl/OrganizationalSchedules.json';
import nlCreateDiseaseProgramPage from './i18n/nl/CreateDiseaseProgramPage.json';
import nlAppointmentDetailPage from './i18n/nl/AppointmentDetailPage.json';
import nlAppointmentTasksPanel from './i18n/nl/AppointmentTasksPanel.json';
import nlOrdersSearchPage from './i18n/nl/OrdersSearchPage.json';
import nlOrderSearch from './i18n/nl/OrderSearch.json';
import nlAdminSettingsSections from './i18n/nl/AdminSettingsSections.json';
import nlgenericSection from './i18n/nl/genericSection.json';
import nlExternalConfigurations from './i18n/nl/ExternalConfigurations.json';
import nlOrdersPage from './i18n/nl/OrdersPage.json';
import nlMedicationTab from './i18n/nl/MedicationTab.json';
import nlNotesVitalsTab from './i18n/nl/NotesVitalsTab.json';
import nlOrderComposer from './i18n/nl/OrderComposer.json';
import nlStepOrderSelector from './i18n/nl/StepOrderSelector.json';
import nlStepCaseAndDetails from './i18n/nl/StepCaseAndDetails.json';
import nlClinicalSettings from './i18n/nl/ClinicalSettings.json';
import nlCreateAppointmentPage from './i18n/nl/CreateAppointmentPage.json';
import nlStepTasks from './i18n/nl/StepTasks.json';
import nlPrevisitTasks from './i18n/nl/PrevisitTasks.json';
import nlNewPatientPage from './i18n/nl/NewPatientPage.json';
import nlAllergiesAndCases from './i18n/nl/AllergiesAndCases.json';
import nlBillingDashboardPage from './i18n/nl/BillingDashboardPage.json';
import nlBillingShell from './i18n/nl/BillingShell.json';
import nlEditPatientPage from './i18n/nl/EditPatientPage.json';
import nlImmunizationsSection from './i18n/nl/ImmunizationsSection.json';
import nlIdentitySection from './i18n/nl/IdentitySection.json';
import nlContactAddressSection from './i18n/nl/ContactAddressSection.json';
import nlPatientBasicsSection from './i18n/nl/PatientBasicsSection.json';
import nlCaseEdit from './i18n/nl/CaseEdit.json';
import nlCaseCaseSections from './i18n/nl/CaseCaseSections.json';
import nlImmunizationSection from './i18n/nl/ImmunizationSection.json';
import nlAllergySection from './i18n/nl/AllergySection.json';
import nlStepGeneralConfig from './i18n/nl/StepGeneralConfig.json';
import nlPreVisitTasks from './i18n/nl/PrevisitTasks.json';
import nlPatientSummaryPage from './i18n/nl/PatientSummaryPage.json';
import nlOverviewPanel from './i18n/nl/OverviewPanel.json';
import nlAllergiesPanel from './i18n/nl/AllergiesPanel.json';
import nlPatientHeader from './i18n/nl/PatientHeader.json';
import nlBedPlannerDashboard from './i18n/nl/BedPlannerDashboard.json';
import nlCreateDocumentModal from './i18n/nl/CreateDocumentModal.json';
import nlVideoForm from './i18n/nl/VideoForm.json';
import nlOrganizationSettings from './i18n/nl/OrganizationSettings.json';
import nlWorkflowDashboard from './i18n/nl/WorkflowDashboard.json';
import nlWorkflowCreate from './i18n/nl/WorkflowCreate.json';
import nlWorkflowTimeSavedSummary from './i18n/nl/WorkflowTimeSavedSummary.json';
import nlworkflowUtils from './i18n/nl/workflowUtils.json';
import nlTemplates from './i18n/nl/Templates.json';
import nlTemplateCreator from './i18n/nl/TemplateCreator.json';
import nlSharedPatientPage from './i18n/nl/SharedPatientPage.json';
import nlPdfViewer from './i18n/nl/PdfViewer.json';
import nlChargesListPage from './i18n/nl/ChargesListPage.json';
import nlAppointmentOverviewSplitSection from './i18n/nl/AppointmentOverviewSplitSection.json';
import nlLegalDocumentsPanel from './i18n/nl/LegalDocumentsPanel.json';
import nlPatientQuestionnairesPanel from './i18n/nl/PatientQuestionnairesPanel.json';
import nlAssignPatientQuestionnaire from './i18n/nl/AssignPatientQuestionnaire.json';
import nlCasesImmunizationsPanel from './i18n/nl/CasesImmunizationsPanel.json';
import nlStepDocuments from './i18n/nl/StepDocuments.json';
import nlStepReview from './i18n/nl/StepReview.json';
import nlAppointmentDetailMainSections from './i18n/nl/AppointmentDetailMainSections.json';
import nlAISummarySection from './i18n/nl/AISummarySection.json';
import nlClaimsListPage from './i18n/nl/ClaimsListPage.json';
import nlClaimEditorPage from './i18n/nl/ClaimEditorPage.json';
import nlReportsLightPage from './i18n/nl/ReportsLightPage.json';
import nlDenialsAppealsPage from './i18n/nl/DenialsAppealsPage.json';
import nlARWorklistsPage from './i18n/nl/ARWorklistsPage.json';
import nlEstimatesPage from './i18n/nl/EstimatesPage.json';
import nlStatementListPage from './i18n/nl/StatementListPage.json';
import nlPaymentsPage from './i18n/nl/PaymentsPage.json';
import nlChargeEditorPage from './i18n/nl/ChargeEditorPage.json';
import nlImpressum from './i18n/nl/Impressum.json';
import nlSignInPage from './i18n/nl/SignInPage.json';
import nlAppointmentsPanel from './i18n/nl/AppointmentsPanel.json';
import nlAppointmentNotesAndSummariesTab from './i18n/nl/AppointmentNotesAndSummariesTab.json';
import nlPatientInviteAction from './i18n/nl/PatientInviteAction.json';
import nlAssignProgramPage from './i18n/nl/AssignProgramPage.json';
import nlMealCreator from './i18n/nl/MealCreator.json';
import nlMealImportModal from './i18n/nl/MealImportModal.json';
import nlCreateExercisePage from './i18n/nl/CreateExercisePage.json';
import nlQuestionnaireByTaskPage from './i18n/nl/QuestionnaireByTaskPage.json';
import nlEditQuestionnairesPage from './i18n/nl/EditQuestionnairesPage.json';
import nlSplashScreen from './i18n/nl/SplashScreen.json';
import nlWorkflowdocument from './i18n/nl/Workflowdocument.json';
import nlUseEditPatient from './i18n/nl/UseEditPatient.json';
import nlDocumentsPanel from './i18n/nl/DocumentsPanel.json';
import nlCaseViewPage from './i18n/nl/CaseViewPage.json';
import nlSearchPreRegisterPage from './i18n/nl/SearchPreRegisterPage.json';
import nlPreRegisterPatientSummaryPage from './i18n/nl/PreRegisterPatientSummaryPage.json';
import nlPublicPatientSummaryRoute from './i18n/nl/PublicPatientSummaryRoute.json';
import nlTasksPanel from './i18n/nl/TasksPanel.json';
import nlVideoTasksSection from './i18n/nl/VideoTasksSection.json';
import nlQuestionnaireWorkflowPage from './i18n/nl/QuestionnaireWorkflowPage.json';
import nlPractitionerDetailPage from './i18n/nl/PractitionerDetailPage.json';
import nlPreRegisterFAQPage from './i18n/nl/PreRegisterFAQPage.json';
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    keySeparator: '.', // nested keys
    ns: [
      'Header', 'ReactAppShell', 'DashboardPage', 'SearchPage', 'CaseViewPage', 'MessagePage',
      'SchedulePage', 'AppointmentPage', 'DiseaseProgramsDashboardPage', 'QuestionnairesPage',
      'MediaPage', 'DocumentDashboard', 'MealPlanner', 'OrganizationPage', 'NewsDashboard',
      'PermissionSettingsPage', 'PractitionersPage', 'OrganizationalSchedules', 'FormPanel',
      'BillingSettingsPage', 'Step0Organization', 'Step1Categories', 'ChatWindow', 'ExternalSystemsSettings',
      'CreateDiseaseProgramPage', 'AppointmentDetailPage', 'AppointmentTasksPanel', 'OrdersSearchPage',
      'OrderSearch', 'AdminSettingsSections', 'genericSection', 'ExternalConfigurations',
      'OrdersPage', 'CreateAppointmentPage', 'StepTasks', 'PrevisitTasks', 'NewPatientPage',
      'AllergiesAndCases', 'BillingDashboardPage', 'BillingShell', 'EditPatientPage',
      'ImmunizationsSection', 'IdentitySection', 'ContactAddressSection', 'PatientBasicsSection',
      'CaseEdit', 'CaseCaseSections', 'ImmunizationSection', 'AllergySection', 'StepGeneralConfig',
      'PreVisitTasks', 'PatientSummaryPage', 'OverviewPanel', 'AllergiesPanel', 'PatientHeader',
      'BedPlannerDashboard', 'CreateDocumentModal', 'VideoForm', 'OrganizationSettings', 'WorkflowDashboard',
      'WorkflowCreate', 'WorkflowTimeSavedSummary', 'workflowUtils', 'Templates', 'TemplateCreator',
      'SharedPatientPage', 'PdfViewer', 'ChargesListPage', 'AppointmentOverviewSplitSection',
      'LegalDocumentsPanel', 'PatientQuestionnairesPanel', 'AssignPatientQuestionnaire', 'CasesImmunizationsPanel', 'StepDocuments', 'StepReview',
      'AppointmentDetailMainSections', 'AISummarySection', 'ClaimsListPage', 'ClaimEditorPage', 'ReportsLightPage',
      'DenialsAppealsPage', 'ARWorklistsPage', 'EstimatesPage', 'StatementListPage', 'PaymentsPage', 'ChargeEditorPage', 
      'Impressum','SignInPage','AppointmentsPanel','AppointmentNotesAndSummariesTab','PatientInviteAction',
      'AssignProgramPage','MealCreator','MealImportModal','CreateExercisePage','QuestionnaireByTaskPage',
      'EditQuestionnairesPage','SplashScreen','Workflowdocument','UseEditPatient','DocumentsPanel','SearchPreRegisterPage',
      'PreRegisterPatientSummaryPage','PublicPatientSummaryRoute','TasksPanel','VideoTasksSection',
      'QuestionnaireWorkflowPage','PractitionerDetailPage','PreRegisterFAQPage'
    ],
    defaultNS: 'header',
    resources: {
      en: {
        header: enHeader,
        ReactAppShell: enShell,
        DashboardPage: enDashboard,
        SearchPage: enSearchPage,
        MessagePage: enMessage,
        SchedulePage: enSchedulePage,
        AppointmentPage: enAppointmentPage,
        DiseaseProgramsDashboardPage: enDiseaseProgram,
        QuestionnairesPage: enQuestionnairesPage,
        MediaPage: enMediaPage,
        DocumentDashboard: enDocumentDashboard,
        MealPlanner: enMealPlanner,
        OrganizationPage: enOrganization,
        NewsDashboard: enNews,
        PermissionSettingsPage: enPermission,
        PractitionersPage: enPractitioner,
        OrganizationalSchedules: enOrganizational,
        FormPanel: enFormPanel,
        ExerciseDashboardPage: enExerciseDashboardPage,
        ClinicalSettingsPage: enClinicalSettingsPage,
        AdministrativeSettingsPage: enAdministrativeSettingsPage,
        BillingSettingsPage: enBillingSettingsPage,
        Step0Organization: enStep0Organization,
        Step1Categories: enStep1Categories,
        ChatWindow: enChatWindow,
        ExternalSystemsSettings: enExternalSystemsSettings,
        CreateDiseaseProgramPage: enCreateDiseaseProgramPage,
        AppointmentDetailPage: enAppointmentDetailPage,
        AppointmentTasksPanel: enAppointmentTasksPanel,
        OrdersSearchPage: enOrdersSearchPage,
        OrderSearch: enOrderSearch,
        AdminSettingsSections: enAdminSettingsSections,
        genericSection: engenericSection,
        ExternalConfigurations: enExternalConfigurations,
        OrdersPage: enOrdersPage,
        MedicationTab: enMedicationTab,
        NotesVitalsTab: enNotesVitalsTab,
        OrderComposer: enOrderComposer,
        StepOrderSelector: enStepOrderSelector,
        StepCaseAndDetails: enStepCaseAndDetails,
        ClinicalSettings: enClinicalSettings,
        CreateAppointmentPage: enCreateAppointmentPage,
        StepTasks: enStepTasks,
        PrevisitTasks: enPrevisitTasks,
        NewPatientPage: enNewPatientPage,
        AllergiesAndCases: enAllergiesAndCases,
        BillingDashboardPage: enBillingDashboardPage,
        BillingShell: enBillingShell,
        EditPatientPage: enEditPatientPage,
        ImmunizationsSection: enImmunizationsSection,
        IdentitySection: enIdentitySection,
        ContactAddressSection: enContactAddressSection,
        PatientBasicsSection: enPatientBasicsSection,
        CaseEdit: enCaseEdit,
        CaseCaseSections: enCaseCaseSections,
        ImmunizationSection: enImmunizationSection,
        AllergySection: enAllergySection,
        StepGeneralConfig: enStepGeneralConfig,
        PreVisitTasks: enPreVisitTasks,
        PatientSummaryPage: enPatientSummaryPage,
        OverviewPanel: enOverviewPanel,
        AllergiesPanel: enAllergiesPanel,
        PatientHeader: enPatientHeader,
        BedPlannerDashboard: enBedPlannerDashboard,
        CreateDocumentModal: enCreateDocumentModal,
        VideoForm: enVideoForm,
        OrganizationSettings: enOrganizationSettings,
        WorkflowDashboard: enWorkflowDashboard,
        WorkflowCreate: enWorkflowCreate,
        WorkflowTimeSavedSummary: enWorkflowTimeSavedSummary,
        workflowUtils: enworkflowUtils,
        Templates: enTemplates,
        TemplateCreator: enTemplateCreator,
        SharedPatientPage: enSharedPatientPage,
        PdfViewer: enPdfViewer,
        ChargesListPage: enChargesListPage,
        AppointmentOverviewSplitSection: enAppointmentOverviewSplitSection,
        LegalDocumentsPanel: enLegalDocumentsPanel,
        PatientQuestionnairesPanel: enPatientQuestionnairesPanel,
        AssignPatientQuestionnaire: enAssignPatientQuestionnaire,
        CasesImmunizationsPanel: enCasesImmunizationsPanel,
        StepDocuments: enStepDocuments,
        StepReview: enStepReview,
        AppointmentDetailMainSections: enAppointmentDetailMainSections,
        AISummarySection: enAISummarySection,
        ClaimsListPage: enClaimsListPage,
        ClaimEditorPage: enClaimEditorPage,
        ReportsLightPage: enReportsLightPage,
        DenialsAppealsPage: enDenialsAppealsPage,
        ARWorklistsPage: enARWorklistsPage,
        EstimatesPage: enEstimatesPage,
        StatementListPage: enStatementListPage,
        PaymentsPage: enPaymentsPage,
        ChargeEditorPage: enChargeEditorPage,
        Impressum: enImpressum,
        SignInPage:enSignInPage,
        AppointmentsPanel:enAppointmentsPanel,
        AppointmentNotesAndSummariesTab:enAppointmentNotesAndSummariesTab,
        PatientInviteAction:enPatientInviteAction,
        AssignProgramPage:enAssignProgramPage,
        MealCreator:enMealCreator,
        MealImportModal:enMealImportModal,
        CreateExercisePage:enCreateExercisePage,
        QuestionnaireByTaskPage:enQuestionnaireByTaskPage,
        EditQuestionnairesPage:enEditQuestionnairesPage,
        SplashScreen:enSplashScreen,
        Workflowdocument:enWorkflowdocument,
        UseEditPatient:enUseEditPatient,
        DocumentsPanel:enDocumentsPanel,
        CaseViewPage:enCaseViewPage,
        SearchPreRegisterPage:enSearchPreRegisterPage,
        PreRegisterPatientSummaryPage:enPreRegisterPatientSummaryPage,
        PublicPatientSummaryRoute:enPublicPatientSummaryRoute,
        TasksPanel:enTasksPanel,
        VideoTasksSection:enVideoTasksSection,
        QuestionnaireWorkflowPage:enQuestionnaireWorkflowPage,
        PractitionerDetailPage:enPractitionerDetailPage,
        PreRegisterFAQPage:enPreRegisterFAQPage
      },
      de: {
        header: deHeader,
        ReactAppShell: deShell,
        DashboardPage: deDashboard,
        SearchPage: deSearchPage,
        CaseViewPage: deCaseViewPage,
        MessagePage: deMessage,
        SchedulePage: deSchedulePage,
        AppointmentPage: deAppointmentPage,
        DiseaseProgramsDashboardPage: deDiseaseProgram,
        QuestionnairesPage: deQuestionnairesPage,
        MediaPage: deMediaPage,
        DocumentDashboard: deDocumentDashboard,
        MealPlanner: deMealPlanner,
        OrganizationPage: deOrganization,
        NewsDashboard: deNews,
        PermissionSettingsPage: dePermission,
        PractitionersPage: dePractitioner,
        OrganizationalSchedules: deOrganizational,
        FormPanel: deFormPanel,
        ExerciseDashboardPage: deExerciseDashboardPage,
        ClinicalSettingsPage: deClinicalSettingsPage,
        AdministrativeSettingsPage: deAdministrativeSettingsPage,
        BillingSettingsPage: deBillingSettingsPage,
        Step0Organization: deStep0Organization,
        Step1Categories: deStep1Categories,
        ChatWindow: deChatWindow,
        ExternalSystemsSettings: deExternalSystemsSettings,
        CreateDiseaseProgramPage: deCreateDiseaseProgramPage,
        AppointmentDetailPage: deAppointmentDetailPage,
        AppointmentTasksPanel: deAppointmentTasksPanel,
        OrdersSearchPage: deOrdersSearchPage,
        OrderSearch: deOrderSearch,
        AdminSettingsSections: deAdminSettingsSections,
        genericSection: degenericSection,
        ExternalConfigurations: deExternalConfigurations,
        OrdersPage: deOrdersPage,
        MedicationTab: deMedicationTab,
        NotesVitalsTab: deNotesVitalsTab,
        OrderComposer: deOrderComposer,
        StepOrderSelector: deStepOrderSelector,
        StepCaseAndDetails: deStepCaseAndDetails,
        ClinicalSettings: deClinicalSettings,
        CreateAppointmentPage: deCreateAppointmentPage,
        StepTasks: deStepTasks,
        PrevisitTasks: dePrevisitTasks,
        NewPatientPage: deNewPatientPage,
        AllergiesAndCases: deAllergiesAndCases,
        BillingDashboardPage: deBillingDashboardPage,
        BillingShell: deBillingShell,
        EditPatientPage: deEditPatientPage,
        ImmunizationsSection: deImmunizationsSection,
        IdentitySection: deIdentitySection,
        ContactAddressSection: deContactAddressSection,
        PatientBasicsSection: dePatientBasicsSection,
        CaseEdit: deCaseEdit,
        CaseCaseSections: deCaseCaseSections,
        ImmunizationSection: deImmunizationSection,
        AllergySection: deAllergySection,
        StepGeneralConfig: deStepGeneralConfig,
        PreVisitTasks: dePreVisitTasks,
        PatientSummaryPage: dePatientSummaryPage,
        OverviewPanel: deOverviewPanel,
        AllergiesPanel: deAllergiesPanel,
        PatientHeader: dePatientHeader,
        BedPlannerDashboard: deBedPlannerDashboard,
        CreateDocumentModal: deCreateDocumentModal,
        VideoForm: deVideoForm,
        OrganizationSettings: deOrganizationSettings,
        WorkflowDashboard: deWorkflowDashboard,
        WorkflowCreate: deWorkflowCreate,
        WorkflowTimeSavedSummary: deWorkflowTimeSavedSummary,
        workflowUtils: deworkflowUtils,
        Templates: deTemplates,
        TemplateCreator: deTemplateCreator,
        SharedPatientPage: deSharedPatientPage,
        PdfViewer: dePdfViewer,
        ChargesListPage: deChargesListPage,
        AppointmentOverviewSplitSection: deAppointmentOverviewSplitSection,
        LegalDocumentsPanel: deLegalDocumentsPanel,
        PatientQuestionnairesPanel: dePatientQuestionnairesPanel,
        AssignPatientQuestionnaire: deAssignPatientQuestionnaire,
        CasesImmunizationsPanel: deCasesImmunizationsPanel,
        StepDocuments: deStepDocuments,
        StepReview: deStepReview,
        AppointmentDetailMainSections: deAppointmentDetailMainSections,
        AISummarySection: deAISummarySection,
        ClaimsListPage: deClaimsListPage,
        ClaimEditorPage: deClaimEditorPage,
        ReportsLightPage: deReportsLightPage,
        DenialsAppealsPage: deDenialsAppealsPage,
        ARWorklistsPage: deARWorklistsPage,
        EstimatesPage: deEstimatesPage,
        StatementListPage: deStatementListPage,
        PaymentsPage: dePaymentsPage,
        ChargeEditorPage: deChargeEditorPage,
        Impressum: deImpressum,
        SignInPage:deSignInPage,
        AppointmentsPanel:deAppointmentsPanel,
        AppointmentNotesAndSummariesTab:deAppointmentNotesAndSummariesTab,
        PatientInviteAction:dePatientInviteAction,
        AssignProgramPage:deAssignProgramPage,
        MealCreator:deMealCreator,
        MealImportModal:deMealImportModal,
        CreateExercisePage:deCreateExercisePage,
        QuestionnaireByTaskPage:deQuestionnaireByTaskPage,
        EditQuestionnairesPage:deEditQuestionnairesPage,
        SplashScreen:deSplashScreen,
        Workflowdocument:deWorkflowdocument,
        UseEditPatient:deUseEditPatient,
        DocumentsPanel:deDocumentsPanel,
        SearchPreRegisterPage:deSearchPreRegisterPage,
        PreRegisterPatientSummaryPage:dePreRegisterPatientSummaryPage,
        PublicPatientSummaryRoute:dePublicPatientSummaryRoute,
        TasksPanel:deTasksPanel,
        VideoTasksSection:deVideoTasksSection,
        QuestionnaireWorkflowPage:deQuestionnaireWorkflowPage,
        PractitionerDetailPage:dePractitionerDetailPage,
          PreRegisterFAQPage:dePreRegisterFAQPage
      },
      ar: {
        header: arHeader,
        ReactAppShell: arShell,
        DashboardPage: arDashboard,
        SearchPage: arSearchPage,
        CaseViewPage: arCaseViewPage,
        MessagePage: arMessage,
        SchedulePage: arSchedulePage,
        AppointmentPage: arAppointmentPage,
        DiseaseProgramsDashboardPage: arDiseaseProgram,
        QuestionnairesPage: arQuestionnairesPage,
        MediaPage: arMediaPage,
        DocumentDashboard: arDocumentDashboard,
        MealPlanner: arMealPlanner,
        OrganizationPage: arOrganization,
        NewsDashboard: arNews,
        PermissionSettingsPage: arPermission,
        PractitionersPage: arPractitioner,
        OrganizationalSchedules: arOrganizational,
        FormPanel: arFormPanel,
        ExerciseDashboardPage: arExerciseDashboardPage,
        ClinicalSettingsPage: arClinicalSettingsPage,
        AdministrativeSettingsPage: arAdministrativeSettingsPage,
        BillingSettingsPage: arBillingSettingsPage,
        Step0Organization: arStep0Organization,
        Step1Categories: arStep1Categories,
        ChatWindow: arChatWindow,
        ExternalSystemsSettings: arExternalSystemsSettings,
        CreateDiseaseProgramPage: arCreateDiseaseProgramPage,
        AppointmentDetailPage: arAppointmentDetailPage,
        AppointmentTasksPanel: arAppointmentTasksPanel,
        OrdersSearchPage: arOrdersSearchPage,
        OrderSearch: arOrderSearch,
        AdminSettingsSections: arAdminSettingsSections,
        genericSection: argenericSection,
        ExternalConfigurations: arExternalConfigurations,
        OrdersPage: arOrdersPage,
        MedicationTab: arMedicationTab,
        NotesVitalsTab: arNotesVitalsTab,
        OrderComposer: arOrderComposer,
        StepOrderSelector: arStepOrderSelector,
        StepCaseAndDetails: arStepCaseAndDetails,
        ClinicalSettings: arClinicalSettings,
        CreateAppointmentPage: arCreateAppointmentPage,
        StepTasks: arStepTasks,
        PrevisitTasks: arPrevisitTasks,
        NewPatientPage: arNewPatientPage,
        AllergiesAndCases: arAllergiesAndCases,
        BillingDashboardPage: arBillingDashboardPage,
        BillingShell: arBillingShell,
        EditPatientPage: arEditPatientPage,
        ImmunizationsSection: arImmunizationsSection,
        IdentitySection: arIdentitySection,
        ContactAddressSection: arContactAddressSection,
        PatientBasicsSection: arPatientBasicsSection,
        CaseEdit: arCaseEdit,
        CaseCaseSections: arCaseCaseSections,
        ImmunizationSection: arImmunizationSection,
        AllergySection: arAllergySection,
        StepGeneralConfig: arStepGeneralConfig,
        PreVisitTasks: arPreVisitTasks,
        PatientSummaryPage: arPatientSummaryPage,
        OverviewPanel: arOverviewPanel,
        AllergiesPanel: arAllergiesPanel,
        PatientHeader: arPatientHeader,
        BedPlannerDashboard: arBedPlannerDashboard,
        CreateDocumentModal: arCreateDocumentModal,
        VideoForm: arVideoForm,
        OrganizationSettings: arOrganizationSettings,
        WorkflowDashboard: arWorkflowDashboard,
        WorkflowCreate: arWorkflowCreate,
        WorkflowTimeSavedSummary: arWorkflowTimeSavedSummary,
        workflowUtils: arworkflowUtils,
        Templates: arTemplates,
        TemplateCreator: arTemplateCreator,
        SharedPatientPage: arSharedPatientPage,
        PdfViewer: arPdfViewer,
        ChargesListPage: arChargesListPage,
        AppointmentOverviewSplitSection: arAppointmentOverviewSplitSection,
        LegalDocumentsPanel: arLegalDocumentsPanel,
        PatientQuestionnairesPanel: arPatientQuestionnairesPanel,
        AssignPatientQuestionnaire: arAssignPatientQuestionnaire,
        CasesImmunizationsPanel: arCasesImmunizationsPanel,
        StepDocuments: arStepDocuments,
        StepReview: arStepReview,
        AppointmentDetailMainSections: arAppointmentDetailMainSections,
        AISummarySection: arAISummarySection,
        ClaimsListPage: arClaimsListPage,
        ClaimEditorPage: arClaimEditorPage,
        ReportsLightPage: arReportsLightPage,
        DenialsAppealsPage: arDenialsAppealsPage,
        ARWorklistsPage: arARWorklistsPage,
        EstimatesPage: arEstimatesPage,
        StatementListPage: arStatementListPage,
        PaymentsPage: arPaymentsPage,
        ChargeEditorPage: arChargeEditorPage,
        Impressum: arImpressum,
        SignInPage:arSignInPage,
        AppointmentsPanel:arAppointmentsPanel,
        AppointmentNotesAndSummariesTab:arAppointmentNotesAndSummariesTab,
        PatientInviteAction:arPatientInviteAction,
        AssignProgramPage:arAssignProgramPage,
        MealCreator:arMealCreator,
        MealImportModal:arMealImportModal,
        CreateExercisePage:arCreateExercisePage,
        QuestionnaireByTaskPage:arQuestionnaireByTaskPage,
        EditQuestionnairesPage:arEditQuestionnairesPage,
        SplashScreen:arSplashScreen,
        Workflowdocument:arWorkflowdocument,
        UseEditPatient:arUseEditPatient,
        DocumentsPanel:arDocumentsPanel,
        SearchPreRegisterPage:arSearchPreRegisterPage,
        PreRegisterPatientSummaryPage:arPreRegisterPatientSummaryPage,
        PublicPatientSummaryRoute:arPublicPatientSummaryRoute,
        TasksPanel:arTasksPanel,
        VideoTasksSection:arVideoTasksSection,
        QuestionnaireWorkflowPage:arQuestionnaireWorkflowPage,
        PractitionerDetailPage:arPractitionerDetailPage,
          PreRegisterFAQPage:arPreRegisterFAQPage
      },
      es: {
  header: esHeader,
  ReactAppShell: esShell,
  DashboardPage: esDashboard,
  SearchPage: esSearchPage,
  MessagePage: esMessage,
  SchedulePage: esSchedulePage,
  AppointmentPage: esAppointmentPage,
  DiseaseProgramsDashboardPage: esDiseaseProgram,
  QuestionnairesPage: esQuestionnairesPage,
  MediaPage: esMediaPage,
  DocumentDashboard: esDocumentDashboard,
  MealPlanner: esMealPlanner,
  OrganizationPage: esOrganization,
  NewsDashboard: esNews,
  PermissionSettingsPage: esPermission,
  PractitionersPage: esPractitioner,
  OrganizationalSchedules: esOrganizational,
  FormPanel: esFormPanel,
  ExerciseDashboardPage: esExerciseDashboardPage,
  ClinicalSettingsPage: esClinicalSettingsPage,
  AdministrativeSettingsPage: esAdministrativeSettingsPage,
  BillingSettingsPage: esBillingSettingsPage,
  Step0Organization: esStep0Organization,
  Step1Categories: esStep1Categories,
  ChatWindow: esChatWindow,
  ExternalSystemsSettings: esExternalSystemsSettings,
  CreateDiseaseProgramPage: esCreateDiseaseProgramPage,
  AppointmentDetailPage: esAppointmentDetailPage,
  AppointmentTasksPanel: esAppointmentTasksPanel,
  OrdersSearchPage: esOrdersSearchPage,
  OrderSearch: esOrderSearch,
  AdminSettingsSections: esAdminSettingsSections,
  genericSection: esgenericSection,
  ExternalConfigurations: esExternalConfigurations,
  OrdersPage: esOrdersPage,
  MedicationTab: esMedicationTab,
  NotesVitalsTab: esNotesVitalsTab,
  OrderComposer: esOrderComposer,
  StepOrderSelector: esStepOrderSelector,
  StepCaseAndDetails: esStepCaseAndDetails,
  ClinicalSettings: esClinicalSettings,
  CreateAppointmentPage: esCreateAppointmentPage,
  StepTasks: esStepTasks,
  PrevisitTasks: esPrevisitTasks,
  NewPatientPage: esNewPatientPage,
  AllergiesAndCases: esAllergiesAndCases,
  BillingDashboardPage: esBillingDashboardPage,
  BillingShell: esBillingShell,
  EditPatientPage: esEditPatientPage,
  ImmunizationsSection: esImmunizationsSection,
  IdentitySection: esIdentitySection,
  ContactAddressSection: esContactAddressSection,
  PatientBasicsSection: esPatientBasicsSection,
  CaseEdit: esCaseEdit,
  CaseCaseSections: esCaseCaseSections,
  ImmunizationSection: esImmunizationSection,
  AllergySection: esAllergySection,
  StepGeneralConfig: esStepGeneralConfig,
  PreVisitTasks: esPreVisitTasks,
  PatientSummaryPage: esPatientSummaryPage,
  OverviewPanel: esOverviewPanel,
  AllergiesPanel: esAllergiesPanel,
  PatientHeader: esPatientHeader,
  BedPlannerDashboard: esBedPlannerDashboard,
  CreateDocumentModal: esCreateDocumentModal,
  VideoForm: esVideoForm,
  OrganizationSettings: esOrganizationSettings,
  WorkflowDashboard: esWorkflowDashboard,
  WorkflowCreate: esWorkflowCreate,
  WorkflowTimeSavedSummary: esWorkflowTimeSavedSummary,
  workflowUtils: esworkflowUtils,
  Templates: esTemplates,
  TemplateCreator: esTemplateCreator,
  SharedPatientPage: esSharedPatientPage,
  PdfViewer: esPdfViewer,
  ChargesListPage: esChargesListPage,
  AppointmentOverviewSplitSection: esAppointmentOverviewSplitSection,
  LegalDocumentsPanel: esLegalDocumentsPanel,
  PatientQuestionnairesPanel: esPatientQuestionnairesPanel,
        AssignPatientQuestionnaire: esAssignPatientQuestionnaire,
  CasesImmunizationsPanel: esCasesImmunizationsPanel,
  StepDocuments: esStepDocuments,
  StepReview: esStepReview,
  AppointmentDetailMainSections: esAppointmentDetailMainSections,
  AISummarySection: esAISummarySection,
  ClaimsListPage: esClaimsListPage,
  ClaimEditorPage: esClaimEditorPage,
  ReportsLightPage: esReportsLightPage,
  DenialsAppealsPage: esDenialsAppealsPage,
  ARWorklistsPage: esARWorklistsPage,
  EstimatesPage: esEstimatesPage,
  StatementListPage: esStatementListPage,
  PaymentsPage: esPaymentsPage,
  ChargeEditorPage: esChargeEditorPage,
  Impressum: esImpressum,
  SignInPage: esSignInPage,
  AppointmentsPanel: esAppointmentsPanel,
  AppointmentNotesAndSummariesTab: esAppointmentNotesAndSummariesTab,
  PatientInviteAction: esPatientInviteAction,
  AssignProgramPage: esAssignProgramPage,
  MealCreator: esMealCreator,
  MealImportModal: esMealImportModal,
  CreateExercisePage: esCreateExercisePage,
  QuestionnaireByTaskPage: esQuestionnaireByTaskPage,
  EditQuestionnairesPage: esEditQuestionnairesPage,
  SplashScreen: esSplashScreen,
  Workflowdocument: esWorkflowdocument,
  UseEditPatient: esUseEditPatient,
  DocumentsPanel: esDocumentsPanel,
  CaseViewPage: esCaseViewPage,
  SearchPreRegisterPage: esSearchPreRegisterPage,
  PreRegisterPatientSummaryPage: esPreRegisterPatientSummaryPage,
  PublicPatientSummaryRoute: esPublicPatientSummaryRoute,
  TasksPanel: esTasksPanel,
  VideoTasksSection: esVideoTasksSection,
  QuestionnaireWorkflowPage: esQuestionnaireWorkflowPage,
  PractitionerDetailPage: esPractitionerDetailPage,
    PreRegisterFAQPage:esPreRegisterFAQPage
},
fr: {
  header: frHeader,
  ReactAppShell: frShell,
  DashboardPage: frDashboard,
  SearchPage: frSearchPage,
  MessagePage: frMessage,
  SchedulePage: frSchedulePage,
  AppointmentPage: frAppointmentPage,
  DiseaseProgramsDashboardPage: frDiseaseProgram,
  QuestionnairesPage: frQuestionnairesPage,
  MediaPage: frMediaPage,
  DocumentDashboard: frDocumentDashboard,
  MealPlanner: frMealPlanner,
  OrganizationPage: frOrganization,
  NewsDashboard: frNews,
  PermissionSettingsPage: frPermission,
  PractitionersPage: frPractitioner,
  OrganizationalSchedules: frOrganizational,
  FormPanel: frFormPanel,
  ExerciseDashboardPage: frExerciseDashboardPage,
  ClinicalSettingsPage: frClinicalSettingsPage,
  AdministrativeSettingsPage: frAdministrativeSettingsPage,
  BillingSettingsPage: frBillingSettingsPage,
  Step0Organization: frStep0Organization,
  Step1Categories: frStep1Categories,
  ChatWindow: frChatWindow,
  ExternalSystemsSettings: frExternalSystemsSettings,
  CreateDiseaseProgramPage: frCreateDiseaseProgramPage,
  AppointmentDetailPage: frAppointmentDetailPage,
  AppointmentTasksPanel: frAppointmentTasksPanel,
  OrdersSearchPage: frOrdersSearchPage,
  OrderSearch: frOrderSearch,
  AdminSettingsSections: frAdminSettingsSections,
  genericSection: frgenericSection,
  ExternalConfigurations: frExternalConfigurations,
  OrdersPage: frOrdersPage,
  MedicationTab: frMedicationTab,
  NotesVitalsTab: frNotesVitalsTab,
  OrderComposer: frOrderComposer,
  StepOrderSelector: frStepOrderSelector,
  StepCaseAndDetails: frStepCaseAndDetails,
  ClinicalSettings: frClinicalSettings,
  CreateAppointmentPage: frCreateAppointmentPage,
  StepTasks: frStepTasks,
  PrevisitTasks: frPrevisitTasks,
  NewPatientPage: frNewPatientPage,
  AllergiesAndCases: frAllergiesAndCases,
  BillingDashboardPage: frBillingDashboardPage,
  BillingShell: frBillingShell,
  EditPatientPage: frEditPatientPage,
  ImmunizationsSection: frImmunizationsSection,
  IdentitySection: frIdentitySection,
  ContactAddressSection: frContactAddressSection,
  PatientBasicsSection: frPatientBasicsSection,
  CaseEdit: frCaseEdit,
  CaseCaseSections: frCaseCaseSections,
  ImmunizationSection: frImmunizationSection,
  AllergySection: frAllergySection,
  StepGeneralConfig: frStepGeneralConfig,
  PreVisitTasks: frPreVisitTasks,
  PatientSummaryPage: frPatientSummaryPage,
  OverviewPanel: frOverviewPanel,
  AllergiesPanel: frAllergiesPanel,
  PatientHeader: frPatientHeader,
  BedPlannerDashboard: frBedPlannerDashboard,
  CreateDocumentModal: frCreateDocumentModal,
  VideoForm: frVideoForm,
  OrganizationSettings: frOrganizationSettings,
  WorkflowDashboard: frWorkflowDashboard,
  WorkflowCreate: frWorkflowCreate,
  WorkflowTimeSavedSummary: frWorkflowTimeSavedSummary,
  workflowUtils: frworkflowUtils,
  Templates: frTemplates,
  TemplateCreator: frTemplateCreator,
  SharedPatientPage: frSharedPatientPage,
  PdfViewer: frPdfViewer,
  ChargesListPage: frChargesListPage,
  AppointmentOverviewSplitSection: frAppointmentOverviewSplitSection,
  LegalDocumentsPanel: frLegalDocumentsPanel,
  PatientQuestionnairesPanel: frPatientQuestionnairesPanel,
        AssignPatientQuestionnaire: frAssignPatientQuestionnaire,
  CasesImmunizationsPanel: frCasesImmunizationsPanel,
  StepDocuments: frStepDocuments,
  StepReview: frStepReview,
  AppointmentDetailMainSections: frAppointmentDetailMainSections,
  AISummarySection: frAISummarySection,
  ClaimsListPage: frClaimsListPage,
  ClaimEditorPage: frClaimEditorPage,
  ReportsLightPage: frReportsLightPage,
  DenialsAppealsPage: frDenialsAppealsPage,
  ARWorklistsPage: frARWorklistsPage,
  EstimatesPage: frEstimatesPage,
  StatementListPage: frStatementListPage,
  PaymentsPage: frPaymentsPage,
  ChargeEditorPage: frChargeEditorPage,
  Impressum: frImpressum,
  SignInPage: frSignInPage,
  AppointmentsPanel: frAppointmentsPanel,
  AppointmentNotesAndSummariesTab: frAppointmentNotesAndSummariesTab,
  PatientInviteAction: frPatientInviteAction,
  AssignProgramPage: frAssignProgramPage,
  MealCreator: frMealCreator,
  MealImportModal: frMealImportModal,
  CreateExercisePage: frCreateExercisePage,
  QuestionnaireByTaskPage: frQuestionnaireByTaskPage,
  EditQuestionnairesPage: frEditQuestionnairesPage,
  SplashScreen: frSplashScreen,
  Workflowdocument: frWorkflowdocument,
  UseEditPatient: frUseEditPatient,
  DocumentsPanel: frDocumentsPanel,
  CaseViewPage: frCaseViewPage,
  SearchPreRegisterPage: frSearchPreRegisterPage,
  PreRegisterPatientSummaryPage: frPreRegisterPatientSummaryPage,
  PublicPatientSummaryRoute: frPublicPatientSummaryRoute,
  TasksPanel: frTasksPanel,
  VideoTasksSection: frVideoTasksSection,
  QuestionnaireWorkflowPage: frQuestionnaireWorkflowPage,
  PractitionerDetailPage: frPractitionerDetailPage,
    PreRegisterFAQPage:frPreRegisterFAQPage
},
it: {
  header: itHeader,
  ReactAppShell: itShell,
  DashboardPage: itDashboard,
  SearchPage: itSearchPage,
  MessagePage: itMessage,
  SchedulePage: itSchedulePage,
  AppointmentPage: itAppointmentPage,
  DiseaseProgramsDashboardPage: itDiseaseProgram,
  QuestionnairesPage: itQuestionnairesPage,
  MediaPage: itMediaPage,
  DocumentDashboard: itDocumentDashboard,
  MealPlanner: itMealPlanner,
  OrganizationPage: itOrganization,
  NewsDashboard: itNews,
  PermissionSettingsPage: itPermission,
  PractitionersPage: itPractitioner,
  OrganizationalSchedules: itOrganizational,
  FormPanel: itFormPanel,
  ExerciseDashboardPage: itExerciseDashboardPage,
  ClinicalSettingsPage: itClinicalSettingsPage,
  AdministrativeSettingsPage: itAdministrativeSettingsPage,
  BillingSettingsPage: itBillingSettingsPage,
  Step0Organization: itStep0Organization,
  Step1Categories: itStep1Categories,
  ChatWindow: itChatWindow,
  ExternalSystemsSettings: itExternalSystemsSettings,
  CreateDiseaseProgramPage: itCreateDiseaseProgramPage,
  AppointmentDetailPage: itAppointmentDetailPage,
  AppointmentTasksPanel: itAppointmentTasksPanel,
  OrdersSearchPage: itOrdersSearchPage,
  OrderSearch: itOrderSearch,
  AdminSettingsSections: itAdminSettingsSections,
  genericSection: itgenericSection,
  ExternalConfigurations: itExternalConfigurations,
  OrdersPage: itOrdersPage,
  MedicationTab: itMedicationTab,
  NotesVitalsTab: itNotesVitalsTab,
  OrderComposer: itOrderComposer,
  StepOrderSelector: itStepOrderSelector,
  StepCaseAndDetails: itStepCaseAndDetails,
  ClinicalSettings: itClinicalSettings,
  CreateAppointmentPage: itCreateAppointmentPage,
  StepTasks: itStepTasks,
  PrevisitTasks: itPrevisitTasks,
  NewPatientPage: itNewPatientPage,
  AllergiesAndCases: itAllergiesAndCases,
  BillingDashboardPage: itBillingDashboardPage,
  BillingShell: itBillingShell,
  EditPatientPage: itEditPatientPage,
  ImmunizationsSection: itImmunizationsSection,
  IdentitySection: itIdentitySection,
  ContactAddressSection: itContactAddressSection,
  PatientBasicsSection: itPatientBasicsSection,
  CaseEdit: itCaseEdit,
  CaseCaseSections: itCaseCaseSections,
  ImmunizationSection: itImmunizationSection,
  AllergySection: itAllergySection,
  StepGeneralConfig: itStepGeneralConfig,
  PreVisitTasks: itPreVisitTasks,
  PatientSummaryPage: itPatientSummaryPage,
  OverviewPanel: itOverviewPanel,
  AllergiesPanel: itAllergiesPanel,
  PatientHeader: itPatientHeader,
  BedPlannerDashboard: itBedPlannerDashboard,
  CreateDocumentModal: itCreateDocumentModal,
  VideoForm: itVideoForm,
  OrganizationSettings: itOrganizationSettings,
  WorkflowDashboard: itWorkflowDashboard,
  WorkflowCreate: itWorkflowCreate,
  WorkflowTimeSavedSummary: itWorkflowTimeSavedSummary,
  workflowUtils: itworkflowUtils,
  Templates: itTemplates,
  TemplateCreator: itTemplateCreator,
  SharedPatientPage: itSharedPatientPage,
  PdfViewer: itPdfViewer,
  ChargesListPage: itChargesListPage,
  AppointmentOverviewSplitSection: itAppointmentOverviewSplitSection,
  LegalDocumentsPanel: itLegalDocumentsPanel,
  PatientQuestionnairesPanel: itPatientQuestionnairesPanel,
        AssignPatientQuestionnaire: itAssignPatientQuestionnaire,
  CasesImmunizationsPanel: itCasesImmunizationsPanel,
  StepDocuments: itStepDocuments,
  StepReview: itStepReview,
  AppointmentDetailMainSections: itAppointmentDetailMainSections,
  AISummarySection: itAISummarySection,
  ClaimsListPage: itClaimsListPage,
  ClaimEditorPage: itClaimEditorPage,
  ReportsLightPage: itReportsLightPage,
  DenialsAppealsPage: itDenialsAppealsPage,
  ARWorklistsPage: itARWorklistsPage,
  EstimatesPage: itEstimatesPage,
  StatementListPage: itStatementListPage,
  PaymentsPage: itPaymentsPage,
  ChargeEditorPage: itChargeEditorPage,
  Impressum: itImpressum,
  SignInPage: itSignInPage,
  AppointmentsPanel: itAppointmentsPanel,
  AppointmentNotesAndSummariesTab: itAppointmentNotesAndSummariesTab,
  PatientInviteAction: itPatientInviteAction,
  AssignProgramPage: itAssignProgramPage,
  MealCreator: itMealCreator,
  MealImportModal: itMealImportModal,
  CreateExercisePage: itCreateExercisePage,
  QuestionnaireByTaskPage: itQuestionnaireByTaskPage,
  EditQuestionnairesPage: itEditQuestionnairesPage,
  SplashScreen: itSplashScreen,
  Workflowdocument: itWorkflowdocument,
  UseEditPatient: itUseEditPatient,
  DocumentsPanel: itDocumentsPanel,
  CaseViewPage: itCaseViewPage,
  SearchPreRegisterPage: itSearchPreRegisterPage,
  PreRegisterPatientSummaryPage: itPreRegisterPatientSummaryPage,
  PublicPatientSummaryRoute: itPublicPatientSummaryRoute,
  TasksPanel: itTasksPanel,
  VideoTasksSection: itVideoTasksSection,
  QuestionnaireWorkflowPage: itQuestionnaireWorkflowPage,
  PractitionerDetailPage: itPractitionerDetailPage,
    PreRegisterFAQPage:itPreRegisterFAQPage
},
nl: {
  header: nlHeader,
  ReactAppShell: nlShell,
  DashboardPage: nlDashboard,
  SearchPage: nlSearchPage,
  MessagePage: nlMessage,
  SchedulePage: nlSchedulePage,
  AppointmentPage: nlAppointmentPage,
  DiseaseProgramsDashboardPage: nlDiseaseProgram,
  QuestionnairesPage: nlQuestionnairesPage,
  MediaPage: nlMediaPage,
  DocumentDashboard: nlDocumentDashboard,
  MealPlanner: nlMealPlanner,
  OrganizationPage: nlOrganization,
  NewsDashboard: nlNews,
  PermissionSettingsPage: nlPermission,
  PractitionersPage: nlPractitioner,
  OrganizationalSchedules: nlOrganizational,
  FormPanel: nlFormPanel,
  ExerciseDashboardPage: nlExerciseDashboardPage,
  ClinicalSettingsPage: nlClinicalSettingsPage,
  AdministrativeSettingsPage: nlAdministrativeSettingsPage,
  BillingSettingsPage: nlBillingSettingsPage,
  Step0Organization: nlStep0Organization,
  Step1Categories: nlStep1Categories,
  ChatWindow: nlChatWindow,
  ExternalSystemsSettings: nlExternalSystemsSettings,
  CreateDiseaseProgramPage: nlCreateDiseaseProgramPage,
  AppointmentDetailPage: nlAppointmentDetailPage,
  AppointmentTasksPanel: nlAppointmentTasksPanel,
  OrdersSearchPage: nlOrdersSearchPage,
  OrderSearch: nlOrderSearch,
  AdminSettingsSections: nlAdminSettingsSections,
  genericSection: nlgenericSection,
  ExternalConfigurations: nlExternalConfigurations,
  OrdersPage: nlOrdersPage,
  MedicationTab: nlMedicationTab,
  NotesVitalsTab: nlNotesVitalsTab,
  OrderComposer: nlOrderComposer,
  StepOrderSelector: nlStepOrderSelector,
  StepCaseAndDetails: nlStepCaseAndDetails,
  ClinicalSettings: nlClinicalSettings,
  CreateAppointmentPage: nlCreateAppointmentPage,
  StepTasks: nlStepTasks,
  PrevisitTasks: nlPrevisitTasks,
  NewPatientPage: nlNewPatientPage,
  AllergiesAndCases: nlAllergiesAndCases,
  BillingDashboardPage: nlBillingDashboardPage,
  BillingShell: nlBillingShell,
  EditPatientPage: nlEditPatientPage,
  ImmunizationsSection: nlImmunizationsSection,
  IdentitySection: nlIdentitySection,
  ContactAddressSection: nlContactAddressSection,
  PatientBasicsSection: nlPatientBasicsSection,
  CaseEdit: nlCaseEdit,
  CaseCaseSections: nlCaseCaseSections,
  ImmunizationSection: nlImmunizationSection,
  AllergySection: nlAllergySection,
  StepGeneralConfig: nlStepGeneralConfig,
  PreVisitTasks: nlPreVisitTasks,
  PatientSummaryPage: nlPatientSummaryPage,
  OverviewPanel: nlOverviewPanel,
  AllergiesPanel: nlAllergiesPanel,
  PatientHeader: nlPatientHeader,
  BedPlannerDashboard: nlBedPlannerDashboard,
  CreateDocumentModal: nlCreateDocumentModal,
  VideoForm: nlVideoForm,
  OrganizationSettings: nlOrganizationSettings,
  WorkflowDashboard: nlWorkflowDashboard,
  WorkflowCreate: nlWorkflowCreate,
  WorkflowTimeSavedSummary: nlWorkflowTimeSavedSummary,
  workflowUtils: nlworkflowUtils,
  Templates: nlTemplates,
  TemplateCreator: nlTemplateCreator,
  SharedPatientPage: nlSharedPatientPage,
  PdfViewer: nlPdfViewer,
  ChargesListPage: nlChargesListPage,
  AppointmentOverviewSplitSection: nlAppointmentOverviewSplitSection,
  LegalDocumentsPanel: nlLegalDocumentsPanel,
  PatientQuestionnairesPanel: nlPatientQuestionnairesPanel,
        AssignPatientQuestionnaire: nlAssignPatientQuestionnaire,
  CasesImmunizationsPanel: nlCasesImmunizationsPanel,
  StepDocuments: nlStepDocuments,
  StepReview: nlStepReview,
  AppointmentDetailMainSections: nlAppointmentDetailMainSections,
  AISummarySection: nlAISummarySection,
  ClaimsListPage: nlClaimsListPage,
  ClaimEditorPage: nlClaimEditorPage,
  ReportsLightPage: nlReportsLightPage,
  DenialsAppealsPage: nlDenialsAppealsPage,
  ARWorklistsPage: nlARWorklistsPage,
  EstimatesPage: nlEstimatesPage,
  StatementListPage: nlStatementListPage,
  PaymentsPage: nlPaymentsPage,
  ChargeEditorPage: nlChargeEditorPage,
  Impressum: nlImpressum,
  SignInPage: nlSignInPage,
  AppointmentsPanel: nlAppointmentsPanel,
  AppointmentNotesAndSummariesTab: nlAppointmentNotesAndSummariesTab,
  PatientInviteAction: nlPatientInviteAction,
  AssignProgramPage: nlAssignProgramPage,
  MealCreator: nlMealCreator,
  MealImportModal: nlMealImportModal,
  CreateExercisePage: nlCreateExercisePage,
  QuestionnaireByTaskPage: nlQuestionnaireByTaskPage,
  EditQuestionnairesPage: nlEditQuestionnairesPage,
  SplashScreen: nlSplashScreen,
  Workflowdocument: nlWorkflowdocument,
  UseEditPatient: nlUseEditPatient,
  DocumentsPanel: nlDocumentsPanel,
  CaseViewPage: nlCaseViewPage,
  SearchPreRegisterPage: nlSearchPreRegisterPage,
  PreRegisterPatientSummaryPage: nlPreRegisterPatientSummaryPage,
  PublicPatientSummaryRoute: nlPublicPatientSummaryRoute,
  TasksPanel: nlTasksPanel,
  VideoTasksSection: nlVideoTasksSection,
  QuestionnaireWorkflowPage: nlQuestionnaireWorkflowPage,
  PractitionerDetailPage: nlPractitionerDetailPage,
    PreRegisterFAQPage:nlPreRegisterFAQPage
},
    },
  });

// --- RTL Support ---
// i18n.on('languageChanged', (lng) => {
//   document.body.dir = lng === 'ar' ? 'rtl' : 'ltr';
// });

export default i18n;
